import faker from 'faker';
import { sum } from 'lodash';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  Card,
  Table,
  Divider,
  TableRow,
  Container,
  TableBody,
  TableHead,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Stack,
  Button,
  IconButton,
  TextField,
  LinearProgress,
  linearProgressClasses,
  Tabs,
  Tab,
  Tooltip,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItem,
  List,
  RadioGroup,
  FormControlLabel,
  Radio,
  Autocomplete,
  AppBar,
  Toolbar,
  Slide,
  CircularProgress,
  Switch,






} from '@material-ui/core';
import { forwardRef, memo, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
// routes
import { PATH_DASHBOARD } from 'src/routes/paths.js';
import { useNavigate, useParams } from 'react-router'
import { ArrowBackIos, ArrowForwardIos, ErrorOutline, Fullscreen, Info, KeyboardBackspaceOutlined, Save, FileCopy } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom'
// utils
import { fCurrency } from 'src/utils/formatNumber.js';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';


// components
import Page from 'src/components/Page.js';
import * as Yup from 'yup';
import Label from 'src/components/Label.js';
import Scrollbar from 'src/components/Scrollbar.js';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import InvoiceToolbar from 'src/components/_dashboard/e-commerce/invoice/InvoiceToolbar.js';
import JobCostToolbar from './JobCostToolbar';
import JobCostCartToolbar from './JobCostCartToolbar';
import ConfirmationPopup from 'src/components/confirmationPopup';
import Icon from '@iconify/react';
import { LoadingButton, Skeleton } from '@material-ui/lab';
import { Form, FormikProvider, useFormik } from 'formik';
import axios from 'axios';
import { COMPANY_NAME, REST_API_END_POINT, UNITS, filteredOtherFacilityTypes } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
import { capitalCase } from 'change-case';
import fakeRequest from 'src/utils/fakeRequest';
import RecipeLog from './RecipeLog';
import { useTheme } from '@emotion/react';
import { Block } from '../components-overview/Block';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '../../components/_dashboard/blog/ProjectModel';
import AddProducts from '../../components/_dashboard/blog/AddProducts';

// ----------------------------------------------------------------------

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  // Split into parts: strings and numbers
  const partsA = a.match(/(\d+|\D+)/g) || [];
  const partsB = b.match(/(\d+|\D+)/g) || [];

  // Compare each part
  const minLength = Math.min(partsA.length, partsB.length);
  for (let i = 0; i < minLength; i++) {
    const partA = partsA[i];
    const partB = partsB[i];

    // If both parts are numbers, compare numerically
    if (/^\d+$/.test(partA) && /^\d+$/.test(partB)) {
      const numA = parseInt(partA, 10);
      const numB = parseInt(partB, 10);
      if (numA !== numB) {
        return numA - numB;
      }
    } else {
      // Otherwise, compare as strings (case-insensitive)
      const strCompare = partA.localeCompare(partB, undefined, { sensitivity: 'base' });
      if (strCompare !== 0) {
        return strCompare;
      }
    }
  }

  // If all parts are equal, shorter string comes first
  return partsA.length - partsB.length;
}

const selectInputValue = (event) => {
  const input = event.target;
  setTimeout(() => {
    if (input?.select) {
      input.select();
    }
  }, 0);
};

// Retail line totals match the table: products use subtotal + markup then round the line to 2dp;
// services round subtotal and markup each to 2dp, then sum (same as service rows in the grid).
function retailProductLineTotal(initialMaxPrice, quantity, retailPricePercent) {
  const totalWithoutMarkup = Number(initialMaxPrice) * Number(quantity || 0);
  const retail_markup = Number(retailPricePercent) || 0;
  const markup_price = (totalWithoutMarkup * retail_markup) / 100;
  const total = totalWithoutMarkup + markup_price;
  return parseFloat(total.toFixed(2));
}

function retailServiceLineTotal(cost, quantity, markupPercentage) {
  const totalWithoutMarkup = parseFloat((Number(cost) * Number(quantity)).toFixed(2));
  const markup_price = parseFloat(((totalWithoutMarkup * Number(markupPercentage || 0)) / 100).toFixed(2));
  return parseFloat((Number(totalWithoutMarkup) + Number(markup_price)).toFixed(2));
}

const ACCOUNT_TABS = [
  {
    value: 'Materials',
    name: 'Materials',
    // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 1)?.length || 0
  },
  {
    value: 'Services',
    name: 'Services',
    // count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
  },
]

// ----------------------------------------------------------------------

const INVOICE = {
  id: faker.datatype.uuid(),
  taxes: 5,
  discount: 10,
  status: 'paid',
  invoiceFrom: {
    name: faker.name.findName(),
    address: 'DieSachbearbeiter Choriner Straße 49 10435 Berlin',
    company: faker.company.companyName(),
    email: faker.internet.email(),
    phone: faker.phone.phoneNumberFormat()
  },
  invoiceTo: {
    name: faker.name.findName(),
    address: 'Keas 69 Str. 15234, Chalandri Athens, Greece',
    company: faker.company.companyName(),
    email: faker.internet.email(),
    phone: faker.phone.phoneNumberFormat()
  },
  items: [...Array(1)].map(() => ({
    id: faker.datatype.uuid(),
    title: faker.lorem.sentence(),
    description: faker.lorem.lines(),
    qty: faker.datatype.number({ min: 1, max: 5 }),
    price: faker.datatype.number({ min: 4, max: 99, precision: 0.01 })
  }))
};

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(0.5),
    // paddingBottom: theme.spacing(0.5)
  }
}));


const data = [
  {
    name: 'Project 1',

    ID: 1,
    unitPrice: 1200.00,
    totalPrice: fCurrency(1200 * 100)

  },
  {
    name: 'Project 2',

    ID: 2,
    unitPrice: 200.00,
    totalPrice: fCurrency(200 * 100)

  },
  {
    name: 'Project 3',

    ID: 3,
    unitPrice: 1400.00,
    totalPrice: fCurrency(1400 * 100)

  },
  {
    name: 'Project 4',

    ID: 4,
    unitPrice: 2000.00,
    totalPrice: fCurrency(2000 * 100)

  },
  {
    name: 'Project 5',

    ID: 5,
    unitPrice: 1000.00,
    totalPrice: fCurrency(1000 * 100)

  },
  {
    name: 'Project 6',

    ID: 6,
    unitPrice: 1200.00,
    totalPrice: fCurrency(1200 * 100)

  },
  {
    name: 'Project 7',

    ID: 7,
    unitPrice: 1500.00,
    totalPrice: fCurrency(1500 * 100)

  },
  {
    name: 'Project 8',

    ID: 8,
    unitPrice: 1100.00,
    totalPrice: fCurrency(1100 * 100)

  },
  {
    name: 'Project 9',

    ID: 9,
    unitPrice: 1400.00,
    totalPrice: fCurrency(1400 * 100)

  },
  {
    name: 'Project 10',

    ID: 10,
    unitPrice: 100.00,
    totalPrice: fCurrency(100 * 100)

  },
  {
    name: 'Project 11',

    ID: 11,
    unitPrice: 1200.00,
    totalPrice: fCurrency(1200 * 100)

  },
  {
    name: 'Project 12',

    ID: 12,
    unitPrice: 1200.00,
    totalPrice: fCurrency(1200 * 100)

  },
  {
    name: 'Project 13',

    ID: 13,
    unitPrice: 1200.00,
    totalPrice: fCurrency(1200 * 100)

  },
  {
    name: 'Project 14',

    ID: 14,
    unitPrice: 1200.00,
    totalPrice: fCurrency(1200 * 100)

  },
  {
    name: 'Project 15',

    ID: 15,
    unitPrice: 1200.00,
    totalPrice: fCurrency(1200 * 100)

  },


]

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  cursor: 'pointer',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',

    WebkitBackdropFilter: 'blur(3px)',
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,

  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',

})

// ----------------------------------------------------------------------
const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

const FORMULA_NAME_MAX_LENGTH = 300

/** Typing state lives here only — parent JobCost does not re-render on each keystroke */
const RecipeFormulaNameTextField = memo(
  forwardRef(function RecipeFormulaNameTextField(
    {
      selectedTab,
      initialValue,
      error,
      helperText,
      sx,
      InputProps,
      InputLabelProps,
      onDebouncedName,
      maxLength = FORMULA_NAME_MAX_LENGTH,
    },
    ref,
  ) {
    const [value, setValue] = useState(() => initialValue || '')
    const debounceTimerRef = useRef()

    useImperativeHandle(
      ref,
      () => ({
        getValue: () => value,
        setValue: (v) => setValue(v ?? ''),
      }),
      [value],
    )

    useEffect(
      () => () => {
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
      },
      [],
    )

    const flushDebounced = (v) => {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
      debounceTimerRef.current = setTimeout(() => {
        onDebouncedName?.(v)
      }, 200)
    }

    const label =
      selectedTab === 'production'
        ? 'Production Formula Name'
        : selectedTab === 'traffic'
          ? 'Traffic Formula Name'
          : selectedTab === 'estimate'
            ? 'Estimate Name'
            : 'Split Formula Name'

    const isOverLimit = value.length > maxLength

    return (
      <TextField
        fullWidth
        name="recipe_name"
        label={label}
        value={value}
        onChange={(e) => {
          const v = e.target.value
          setValue(v)
          flushDebounced(v)
        }}
        error={error || isOverLimit}
        helperText={
          isOverLimit
            ? `Maximum ${maxLength} characters allowed (${value.length}/${maxLength})`
            : helperText
        }
        sx={sx}
        InputProps={InputProps}
        InputLabelProps={InputLabelProps}
      />
    )
  }),
)

export default function JobCost({fromSplitEstimate,formulaName,onRecipeCreated,setRecipes,formulaTab,recipeId,fromAddProductsEdit,hideSaveAsCopy}) {

  const { enqueueSnackbar } = useSnackbar();
  const user = JSON.parse(window.localStorage.getItem('user'))
  const explodedPermissions = user?.exploded_permissions
  const AddCatalogPermission = explodedPermissions?.some(_permission_ => ['Add Catalog'].includes(_permission_))
  const subTotal = sum(INVOICE.items.map((item) => item.price * item.qty));
  const total = subTotal - INVOICE.discount + INVOICE.taxes;
  const [isHover, setIsHover] = useState(false)
  const [productList, setProductList] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [isDelete, setIsDelete] = useState(false)
  const [totalPayOut, setTotalPayOut] = useState(0)
  const [jobCost, setJobCost] = useState(1000)
  const [openSaveOriginalConfirm, setOpenSaveOriginalConfirm] = useState(false);
  const[recipeName,setRecipeName]=useState("")
  const navigate = useNavigate();
  const location = useLocation();
  // Persist edit-page location.state so recipe id/tab survive browser refresh.
  // Never use history.pushState(null) on this page — it wipes React Router state
  // and causes recipe details to load empty / get saved as null.
  const RECIPE_EDIT_STATE_KEY = 'signwise_recipe_edit_page_state';
  const [persistedEditState] = useState(() => {
    try {
      const navEntry = performance.getEntriesByType?.('navigation')?.[0];
      const isReload =
        navEntry?.type === 'reload' ||
        (typeof performance.navigation !== 'undefined' && performance.navigation.type === 1);
      // Only restore on browser refresh — avoids loading a stale recipe id on a fresh visit
      if (!isReload) return null;
      return JSON.parse(sessionStorage.getItem(RECIPE_EDIT_STATE_KEY) || 'null');
    } catch {
      return null;
    }
  });
  useEffect(() => {
    if (location.state && typeof location.state === 'object') {
      sessionStorage.setItem(RECIPE_EDIT_STATE_KEY, JSON.stringify(location.state));
    }
  }, [location.state]);
  const editPageState = location.state || persistedEditState || {};
  const [search,setSearch] = useState('')
  const [filterName,setFilterName] = useState('')
  /** Ref to isolated name field — value read on submit; no parent re-render while typing */
  const recipeNameInputRef = useRef(null)
  /** Debounced mirror for split-formula autocomplete match (parent updates ~200ms, not every key) */
  const [recipeNameMirror, setRecipeNameMirror] = useState('')
  const [recipeNameFieldErrors, setRecipeNameFieldErrors] = useState({})
  const initialRecipeName = useMemo(
    () =>
      (fromSplitEstimate ? formulaName : recipeId && formulaName ? formulaName : recipeName) || '',
    [fromSplitEstimate, formulaName, recipeId, recipeName],
  )
  const params = recipeId || editPageState?.id;
  const [color, setColor] = useState('#308fe8')
  const [tab, setTab] = useState(false)
  const [currentTab, setCurrentTab] = useState('Materials')
  const [showDetailsWithoutMarkup,setShowDetailsWithoutMarkup] = useState(true)
  const tableContainerRef = useRef(null);
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [pendingProject, setPendingProject] = useState(null);
  const [stockType, setStockType] = useState(1);
  const [partialProducts, setPartialProducts] = useState([]);
  const [convertionUnit, setConvertionUnit] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(false);
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [facilityPopupOpen, setFacilityPopupOpen] = useState(false);
  const [pendingService, setPendingService] = useState(null);
  const [otherInstallationSplitInstallLabour, setOtherInstallationSplitInstallLabour] = useState([]);
  const [allRecipes, setAllRecipes] = useState([]);
  const [splitRecipeOptions, setSplitRecipeOptions] = useState([]);
  const selectedTab = ((formulaTab || editPageState?.tab || 'production') + '').toLowerCase()
  const [hasRecipeChanges, setHasRecipeChanges] = useState(false);
  const [formulaView, setFormulaView] = useState('name'); // 'name' | 'description'
  const [selectedSplitRecipeId, setSelectedSplitRecipeId] = useState(null);
  const [workflows, setWorkflows] = useState([])
  const [selectedWorkflow, setSelectedWorkflow] = useState(null);
  const [previosWorkflowId, setPreviosWorkflowId] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [debouncedFilterName, setDebouncedFilterName] = useState('');
  const [materialsPage, setMaterialsPage] = useState(0);
  const [materialsRowsPerPage, setMaterialsRowsPerPage] = useState(40);
  const [materialsTotalCount, setMaterialsTotalCount] = useState(0);
  const [hasMoreMaterials, setHasMoreMaterials] = useState(true);
  const [servicesPage, setServicesPage] = useState(0);
  const [servicesRowsPerPage, setServicesRowsPerPage] = useState(40);
  const [servicesTotalCount, setServicesTotalCount] = useState(0);
  const [hasMoreServices, setHasMoreServices] = useState(true);
  const [materialsLoading, setMaterialsLoading] = useState(false);
  const [servicesLoading, setServicesLoading] = useState(false);
  const suppressTabFetchRef = useRef(true);

  
  // Auto-save confirmation dialog state
  const [openBackConfirm, setOpenBackConfirm] = useState(false);

  // Catalog related states
  const [openCatalogConfirmation, setOpenCatalogConfirmation] = useState(false);
  const [openCatalogModal, setOpenCatalogModal] = useState(false);
  const [openCatalogTypeDialog, setOpenCatalogTypeDialog] = useState(false);
  const [selectedCatalogType, setSelectedCatalogType] = useState(null);
  const [savedRecipeData, setSavedRecipeData] = useState(null);
  const [submitActionLoading, setSubmitActionLoading] = useState(false);
  const listPage = location.state?.listPage ?? 0;
  const rowsPerPage = location.state?.rowsPerPage ?? 50;
  const normalizeText = (str) => str?.toLowerCase().replace(/\s+/g, ' ').trim() || '';
  const getProjectRowKey = (project) => {
    // Existing saved recipe material:
    // product_id is the unique recipe ingredient row id
    if (project?.product_id != null) {
      return `ingredient-${project.product_id}`;
    }
  
    // Newly-added material which is not saved yet
    return `new-${project?.id}-${project?.stockType}-${project?.convertionUnit ?? project?.unit ?? 'none'}`;
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 180);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    if (currentTab === 'Materials') {
      setMaterialsPage(0);
    }
    if (currentTab === 'Services') {
      setServicesPage(0);
    }
  }, [debouncedSearch, currentTab]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilterName(filterName);
    }, 180);
    return () => clearTimeout(timer);
  }, [filterName]);
const handleOpenFullscreen = () => {
  const v = recipeNameInputRef.current?.getValue?.() ?? ''
  setRecipeNameMirror(v)
  setFullscreenOpen(true)
}

const handleCloseFullscreen = () => {
  const v = recipeNameInputRef.current?.getValue?.() ?? ''
  setRecipeNameMirror(v)
  setFullscreenOpen(false)
}

  // Catalog type options for production formula
  const catalogTypeOptions = [
    { id: 'production_catalog', label: 'Production Catalog', inhouse: true, isTrafficCatalog: false, selectedTab: undefined },
    { id: 'in_stock_catalog', label: 'In Stock Catalog', inhouse: 4, isTrafficCatalog: false, selectedTab: 'in_stock_catalog' },
    { id: 'client_owned_catalog', label: 'Client Owned Catalog', inhouse: 5, isTrafficCatalog: false, selectedTab: 'client_owned_catalog' },
    { id: 'estimate_catalog', label: 'Estimate Catalog', inhouse: 7, isTrafficCatalog: false, selectedTab: 'estimate_catalog' },
  ];

  const handleCatalogConfirmationYes = () => {
    setSubmitActionLoading(false);
    setOpenCatalogConfirmation(false);
    
    // For production formula, show catalog type selection dialog
    // For traffic and split, directly open the catalog modal
    if (selectedTab === 'production') {
      setOpenCatalogTypeDialog(true);
    } else {
      // For traffic or split, directly open with appropriate settings
      setOpenCatalogModal(true);
    }
  };

  const handleCatalogConfirmationSkip = () => {
    setSubmitActionLoading(false);
    setOpenCatalogConfirmation(false);
    setSavedRecipeData(null);
    // Continue with normal navigation
    if (!fromSplitEstimate && !formulaTab) {
      navigate(PATH_DASHBOARD.products.recipe, { state: { tab: selectedTab,listPage: listPage,rowsPerPage: rowsPerPage,scrollToProductId: params } });
    }
  };

  const handleCatalogTypeSelect = (catalogType) => {
    setSelectedCatalogType(catalogType);
    setOpenCatalogTypeDialog(false);
    setOpenCatalogModal(true);
  };

  const handleCloseCatalogTypeDialog = () => {
    setOpenCatalogTypeDialog(false);
    setSelectedCatalogType(null);
    setSavedRecipeData(null);
    // Navigate back to recipe list
    if (!fromSplitEstimate && !formulaTab) {
      navigate(PATH_DASHBOARD.products.recipe, { state: { tab: selectedTab,listPage: listPage,rowsPerPage: rowsPerPage,scrollToProductId: params } });
    }
  };

  const handleCloseCatalogModal = () => {
    setOpenCatalogModal(false);
    setSelectedCatalogType(null);
    setSavedRecipeData(null);
    // Navigate back to recipe list
    if (!fromSplitEstimate && !formulaTab) {
      navigate(PATH_DASHBOARD.products.recipe, { state: { tab: selectedTab,listPage: listPage,rowsPerPage: rowsPerPage,scrollToProductId: params } });
    }
  };


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleProductClick = (project) => {
    console.log('project==project==',project);
    setPendingProject(project);
    handleClickOpen(); // Open the popup
    // change will be committed only after submit popup

    // let a= !selectedProjects.map(s => s.id).includes(post.id) ? handleProjectClick({ ...post, quantity: 1 }) : enqueueSnackbar('Product Already Added', { variant: 'error' }) removve let a= and place this on the onclick function
  };

  const handleSubmitPopUp = () => {
    if (pendingProject) {
      if(stockType == 2 && !convertionUnit){
        enqueueSnackbar('Please choose a conversion unit', { variant: 'error' });
        return;
      }
      console.log('stockType----',stockType)
      console.log('convertionUnit----',convertionUnit)
      let width = stockType == 1 ? null : 1
      let convertionQty = stockType == 1 ? null : 1
      console.log("Selected Projects Before Update:", pendingProject);
      if(stockType == 2 && pendingProject?.partial == 0 && pendingProject?.partialProductQty <= 0){
        return enqueueSnackbar('No Partial Stock Found', { variant: 'error' });
      }
      // else if(stockType == 1 && pendingProject?.finishedProductQty <= 0){
      //   return enqueueSnackbar('No Stock Found', { variant: 'error' });
      // }
      if (!selectedProjects.some(s => ((s.id === pendingProject.id) && (s.stockType === stockType)))) {
        // const quantity = stockType == 1 ? pendingProject?.finishedProductQty : pendingProject?.partialProductQty
        let initial_max_price = 0;
        let unit = 4;
        let quantity = 1;
        let partialProductQty = 0;
        if(stockType == 1){
          initial_max_price = pendingProject.max_price ? pendingProject.max_price : pendingProject.special_price
          unit = pendingProject.unit ? pendingProject.unit : 0
          // quantity = pendingProject.finishedProductQty ? pendingProject.finishedProductQty : 0
        }else{
          const filteredpartial = partialProducts?.find((item)=>item?.partial_unit == convertionUnit)
          initial_max_price = filteredpartial?.max_unit_cost ? filteredpartial?.max_unit_cost : 0
          unit = filteredpartial?.partial_unit ? filteredpartial?.partial_unit : 0
          // quantity = filteredpartial?.total_qty ? filteredpartial?.total_qty : 0
          partialProductQty = filteredpartial?.total_qty ? filteredpartial?.total_qty : 0
        }
        setSelectedProjects(prevSelectedProjects => [...prevSelectedProjects, { ...pendingProject, partialProductQty, unit, max_price: 0, initial_max_price, quantity, initialQty: quantity,  stockType, convertionUnit  }]);
        setHasRecipeChanges(true);
      } else {
        enqueueSnackbar('Product Already Added', { variant: 'error' });
      }
      setPendingProject(null); // Reset pending project
    }
    handleClose(); // Close the popup
  };

  const showWIthoutMarkupDetails = (isChecked)=>{
    setShowDetailsWithoutMarkup(isChecked)
  }


  const logo = 'https://www.shutterstock.com/image-photo/checklist-clipboard-task-documentation-management-260nw-2270860299.jpg'

  const { id } = useParams();

  const handleChangeTab = (event, newValue) => {
    if(newValue == 'Materials'){
      setCurrentTab(newValue);
      setTab(false);
    }else{
      setCurrentTab(newValue);
      setTab(true);
    }
  };

  const handleMaterialsPageChange = (event, newPage) => {
    setMaterialsPage(newPage);
  };

  const handleMaterialsRowsPerPageChange = (event) => {
    const nextRowsPerPage = parseInt(event.target.value, 10) || 10;
    setMaterialsRowsPerPage(nextRowsPerPage);
    setMaterialsPage(0);
  };

  const handleServicesPageChange = (event, newPage) => {
    setServicesPage(newPage);
  };

  const handleServicesRowsPerPageChange = (event) => {
    const nextRowsPerPage = parseInt(event.target.value, 10) || 10;
    setServicesRowsPerPage(nextRowsPerPage);
    setServicesPage(0);
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: `hsl(${120 - (progressValue * 1.2)}, ${60}%, 50%)`, // `hsl(${(progressValue * 1.2)}, ${60 + (progressValue * 0.4)}%, 50%)`
    },
  }));

  function alphanumericCompare(str1, str2) {
    const normalize = (str) => {
      if (str === null || str === undefined) return '';
      // Strip leading and trailing quotes before comparison
      let normalized = str.toString().trim();
      // Remove leading and trailing quotes (both single and double)
      normalized = normalized.replace(/^["']+|["']+$/g, '');
      return normalized;
    };
  
    const a = normalize(str1);
    const b = normalize(str2);
  
    if (!a && !b) return 0;
    if (!a) return -1;
    if (!b) return 1;
  
    const getChunks = (str) => {
      const chunks = [];
      let currentChunk = '';
      let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'
  
      for (let i = 0; i < str.length; i++) {
        const char = str[i];
        const isDigit = /\d/.test(char);
        const isLetter = /[a-zA-Z]/.test(char);
        const isHash = char === '#';
        const isOtherSpecial = !isDigit && !isLetter && !isHash;
        
        // Determine chunk type with priority: hash < otherSpecial < digit < letter
        let currentType;
        if (isHash) {
          currentType = 'hash';
        } else if (isOtherSpecial) {
          currentType = 'otherSpecial';
        } else if (isDigit) {
          currentType = 'digit';
        } else {
          currentType = 'letter';
        }
  
        if (i === 0) {
          chunkType = currentType;
          currentChunk = char;
        } else if (currentType === chunkType) {
          currentChunk += char;
        } else {
          chunks.push({
            value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
            type: chunkType
          });
          currentChunk = char;
          chunkType = currentType;
        }
      }
  
      if (currentChunk) {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
      }
  
      return chunks;
    };
  
    const chunksA = getChunks(a);
    const chunksB = getChunks(b);
    const len = Math.min(chunksA.length, chunksB.length);
  
    // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
    const getTypePriority = (type) => {
      if (type === 'hash') return 0;
      if (type === 'otherSpecial') return 1;
      if (type === 'digit') return 2;
      return 3; // letter
    };
  
    for (let i = 0; i < len; i++) {
      const chunkA = chunksA[i];
      const chunkB = chunksB[i];
  
      const priorityA = getTypePriority(chunkA.type);
      const priorityB = getTypePriority(chunkB.type);
  
      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }
  
      // Same type, compare values
      if (chunkA.type === 'digit') {
        if (chunkA.value < chunkB.value) return -1;
        if (chunkA.value > chunkB.value) return 1;
      } else {
        if (chunkA.value < chunkB.value) return -1;
        if (chunkA.value > chunkB.value) return 1;
      }
    }
  
    if (chunksA.length < chunksB.length) return -1;
    if (chunksA.length > chunksB.length) return 1;
  
    return 0;
  }

  const getAllWorkflows = async () => {
    try {
      axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products`)
        .then((res) => {
          // Sort alphanumerically by name
          const sortedWorkflows = [...(res.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setWorkflows(sortedWorkflows)
        })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.log(error)
    }
  }
  


  useEffect(() => {
      if (fromSplitEstimate) {
        fetchSplitRecipes();
      }
      getAllWorkflows()
      // Initial load: fetch both tabs once
      fetchData({ page: materialsPage, limit: materialsRowsPerPage, searchText: '', loadSelected: true });
      fetchServiceData({ page: servicesPage, limit: servicesRowsPerPage, searchText: '', loadSelected: true });
      const timer = setTimeout(() => {
        suppressTabFetchRef.current = false;
      }, 0);
      return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (suppressTabFetchRef.current) return;
    if (currentTab !== 'Materials') return;
    fetchData({
      page: materialsPage,
      limit: materialsRowsPerPage,
      searchText: debouncedSearch,
      loadSelected: false,
      isAppend: materialsPage > 0
    });
  }, [materialsPage, materialsRowsPerPage, debouncedSearch, currentTab]);

  useEffect(() => {
    if (suppressTabFetchRef.current) return;
    if (currentTab !== 'Services') return;
    fetchServiceData({
      page: servicesPage,
      limit: servicesRowsPerPage,
      searchText: debouncedSearch,
      loadSelected: false,
      isAppend: servicesPage > 0
    });
  }, [servicesPage, servicesRowsPerPage, debouncedSearch, currentTab]);

  useEffect(() => {
    if (fromSplitEstimate && params) {
      setSelectedSplitRecipeId(params);
    }
  }, [fromSplitEstimate, params]);

  useEffect(()=>{
    if(previosWorkflowId && workflows.length > 0){
      let workflow = workflows.find(workflow => workflow.id == previosWorkflowId)
      console.log('setSelectedWorkflow----',workflow);
      setSelectedWorkflow(workflow)
     }
  },[previosWorkflowId,workflows])

  const fetchSplitRecipes = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}product/get-all-recipes`);
      if (res?.data?.status === 1 && Array.isArray(res?.data?.recipes)) {
        const splitOnly = res.data.recipes.filter((item) => item?.type === 3);
        // Sort alphanumerically by name
        const sortedSplitOnly = [...splitOnly].sort((a, b) => 
          alphanumericCompare(a?.name || '', b?.name || '')
        );
        setSplitRecipeOptions(sortedSplitOnly);
      } else {
        setSplitRecipeOptions([]);
      }
    } catch (error) {
      console.error('Error fetching split formulas:', error);
      setSplitRecipeOptions([]);
    }
  };


  const progressValue = useMemo(() => {
    const totalExpectedMaterialCost = selectedProjects?.reduce((accumulator, currentValue) => {
      return accumulator + (currentValue.max_price * currentValue.quantity);
    }, 0)
    const totalExpectedServiceCost = selectedServices?.reduce((accumulator, currentValue) => {
      return accumulator + (currentValue.cost * currentValue.quantity);
    }, 0)
    const Cost = jobCost / (totalExpectedMaterialCost + totalExpectedServiceCost + Number(totalPayOut)) * 100
    if (Cost > 100) {
      return 100
    } else {
      return Cost
    }
  }, [selectedProjects,selectedServices, totalPayOut])

  const fetchData = ({ page = materialsPage, limit = materialsRowsPerPage, searchText = debouncedSearch, loadSelected = true, isAppend = false } = {}) => {
    setMaterialsLoading(true)
    try {
      axios.post(`${REST_API_END_POINT}recipe/get-all-materials-optimized`, {
        userId: user.user_id,
        params,
        page: Number(page) + 1,
        limit,
        search: searchText
      }).then((response) => {
        // const productListData = response.data.results
        let materialsData= response.data.results
        const productListData = materialsData || []
        let selectedProducts =[]
        // console.log("XHznnn",response.data.selectedMaterials);
        const allPayouts = response.data.allPayOut
        // console.log("######################Pay", response.data.allPayOut);
        if(loadSelected && response.data.selectedMaterials.length>0){
          // console.log("#########reee",response.data.selectedMaterials.length);
    
          selectedProducts = response.data.selectedMaterials[0]?.ingredients
        
          if (!fromSplitEstimate) {
            setRecipeName(response.data.selectedMaterials[0]?.name)
          }
          setPreviosWorkflowId(response.data.selectedMaterials[0]?.workflow_id)
          // Initialize the Name/Description toggle based on stored value (1=name, 2=description)
          const storedView = response.data.selectedMaterials[0]?.name_or_description;
          if (storedView === 1) {
            setFormulaView('description');
          } else if (storedView === 0) {
            setFormulaView('name');
          }
        }
        if (allPayouts?.length > 0) {
          let totalPayOut = allPayouts?.reduce((acc, curr) => acc + curr.amount, 0)
          // console.log("######################Payentet", totalPayOut);
          setTotalPayOut(allPayouts?.reduce((acc, curr) => acc + curr.amount, 0))
        }

        if (productListData) {
          const activeMaterials = productListData?.filter((item) => item.status == 1);
          // Sorting is now handled by backend for consistency in infinite scroll
          setProductList((prev) => {
            if (!isAppend) return activeMaterials;
            const existingIds = new Set(prev.map(p => p.id));
            const newMaterials = activeMaterials.filter(p => !existingIds.has(p.id));
            return [...prev, ...newMaterials];
          });
          setHasMoreMaterials(productListData.length === limit);
        }
        setMaterialsTotalCount(Number(response?.data?.totalCount || 0));
        // console.log("XHznnn",selectedProducts);
        if (loadSelected && response.data.selectedMaterials[0]?.ingredients?.length) {
          const selectedMaterialProducts = response?.data?.selectedMaterialProducts || [];
          const selectedProductsBase = selectedMaterialProducts.length > 0 ? selectedMaterialProducts : productListData;
          // console.log("XHznnn",selectedProducts);
          // setSelectedProjects(productListData.filter(item1 =>
          //   selectedProducts.some(item2 => item1.id === item2.product_id)
          // ).map(item1 => {
          //   let match = selectedProducts.find(item2 => item1.id === item2.product_id);
          //   console.log("#########Nush123",match);
          //   return { ...item1, ...(match ? { product_id: match.id, quantity: match.quantity,
          //     max_price: 0,
          //     initial_max_price: match?.stockType == 2 ? match?.max_partial_unit_cost : item1.max_price ? item1.max_price : 0,
          //     initialQty: match.quantity || 1,
          //     partialProductQty: match.total_partial_stock,
          //     convertionUnit: match?.convertionUnit || null,
          //     width: match?.width || null,
          //     stockType: match?.stockType || 1,
          //     unit: match?.stockType == 2 ? match?.convertionUnit : match?.unit,
          //     convertionQty: match?.convertionQty || null,
          //    } : {}) };
          // }))
          setSelectedProjects(
            selectedProductsBase
              .filter(item1 =>
                selectedProducts.some(item2 => item1.id === item2.product_id)
              )
              .flatMap(item1 => {
                let matches = selectedProducts.filter(item2 => item1.id === item2.product_id); // ✅ Get all matches
                return matches.map(match => {
                  // Partial: recipe convertionUnit / partial_unit (not finished parent convertion_unit)
                  // Finished: prefer convertion_unit from material_inventory (API), then recipe ingredient
                  const inventoryConvertionUnit =
                    match?.stockType == 2
                      ? (match?.convertionUnit || match?.partial_unit || item1?.partial_unit || null)
                      : (match?.convertion_unit ||
                        match?.convertionUnit ||
                        item1?.convertion_unit ||
                        null);
                  return {
                  ...item1,
                  product_id: match.id,
                  quantity: match.quantity,
                  max_price: 0,
                  initial_max_price: match?.stockType == 2 ? match?.max_partial_unit_cost : item1.max_price || item1.special_price || 0,
                  initialQty: match.quantity || 1,
                  partialProductQty: match.total_partial_stock,
                  convertionUnit: inventoryConvertionUnit,
                  convertion_unit: inventoryConvertionUnit,
                  width: match?.width || null,
                  stockType: match?.stockType || 1,
                  unit: match?.stockType == 2 ? inventoryConvertionUnit : match?.unit,
                  convertionQty: match?.convertionQty || null,
                };
                });
              })
          );          
        }
      }).catch((error) => {
        console.error("Error fetching data:", error);
      }).finally(() => {
        setMaterialsLoading(false);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
      setMaterialsLoading(false);
    }finally{
    }
  }

const fetchPartialProducts = async () => {
    setLoading(true)
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-partial-finished-products-stock-by-unit`,{editId:pendingProject?.id});
      const productListData = response.data.results;
      if(productListData){
        setPartialProducts(productListData);
      }
      else{
        setPartialProducts([]);
      }
    }
      catch (error) {
      console.error("Error fetching data:", error);
    }
    finally{
      setLoading(false);
    }
  }
  useEffect( async () => {
    if(pendingProject){
      fetchPartialProducts();
    }
  }, [pendingProject]);

  const loadSplitFormulaSelections = async (recipeIdToLoad) => {
    if (!recipeIdToLoad) return;
    setMaterialsLoading(true);
    setServicesLoading(true);
    setSelectedSplitRecipeId(recipeIdToLoad);
    setHasRecipeChanges(false);
    try {
      const [materialsRes, servicesRes] = await Promise.all([
        axios.post(`${REST_API_END_POINT}recipe/get-all-materials-optimized`, {
          userId: user.user_id,
          params: recipeIdToLoad,
          page: materialsPage + 1,
          limit: materialsRowsPerPage,
          search: currentTab === 'Materials' ? debouncedSearch : ''
        }),
        axios.post(`${REST_API_END_POINT}recipe/get-all-services-optimized`, {
          userId: user.user_id,
          params: recipeIdToLoad,
          page: servicesPage + 1,
          limit: servicesRowsPerPage,
          search: currentTab === 'Services' ? debouncedSearch : ''
        }),
      ]);

      // Materials
      const materialsData = materialsRes?.data?.results || [];
      const materialsSelected = materialsRes?.data?.selectedMaterials?.[0];
      const products = materialsData || [];
      const selectedProductsData = materialsRes?.data?.selectedMaterialProducts || [];
      const selectedProductsBase = selectedProductsData.length > 0 ? selectedProductsData : products;
      const selectedIngredients = materialsSelected?.ingredients || [];
      setMaterialsTotalCount(Number(materialsRes?.data?.totalCount || 0));

      if (selectedIngredients?.length) {
        setSelectedProjects(
          selectedProductsBase
            .filter((item1) => selectedIngredients.some((item2) => item1.id === item2.product_id))
            .flatMap((item1) => {
              const matches = selectedIngredients.filter((item2) => item1.id === item2.product_id);
              return matches.map((match) => {
                // Partial: recipe convertionUnit / partial_unit (not finished parent convertion_unit)
                // Finished: prefer convertion_unit from material_inventory (API), then recipe ingredient
                const inventoryConvertionUnit =
                  match?.stockType == 2
                    ? (match?.convertionUnit || match?.partial_unit || item1?.partial_unit || null)
                    : (match?.convertion_unit ||
                      match?.convertionUnit ||
                      item1?.convertion_unit ||
                      null);
                return {
                ...item1,
                product_id: match.id,
                quantity: match.quantity,
                max_price: 0,
                initial_max_price: match?.stockType == 2 ? match?.max_partial_unit_cost : item1.max_price || item1.special_price || 0,
                initialQty: match.quantity || 1,
                partialProductQty: match.total_partial_stock,
                convertionUnit: inventoryConvertionUnit,
                convertion_unit: inventoryConvertionUnit,
                width: match?.width || null,
                stockType: match?.stockType || 1,
                unit: match?.stockType == 2 ? inventoryConvertionUnit : match?.unit,
                convertionQty: match?.convertionQty || null,
              };
              });
            })
        );
      } else {
        setSelectedProjects([]);
      }

      // Services
      const servicesData = servicesRes?.data?.results || [];
      const servicesSelected = servicesRes?.data?.selectedMaterials?.[0];
      const servicesList = servicesData?.filter((row) => row.inhouse !== 2) || [];
      const selectedServicesData = (servicesRes?.data?.selectedServiceProducts || []).filter((row) => row.inhouse !== 2) || [];
      const selectedServicesBase = selectedServicesData.length > 0 ? selectedServicesData : servicesList;
      const selectedServicesFromRecipe = servicesSelected?.services || [];
      setServicesTotalCount(Number(servicesRes?.data?.totalCount || 0));

      // Store split install labour if present
      if ((selectedTab === 'split' || fromSplitEstimate) && servicesRes?.data?.otherInstallationSplitInstallLabour) {
        setOtherInstallationSplitInstallLabour(servicesRes.data.otherInstallationSplitInstallLabour);
      }

      if (selectedServicesFromRecipe?.length) {
        setSelectedServices(
          selectedServicesBase
            .filter((item1) => selectedServicesFromRecipe.some((item2) => item1.id === item2.service_id))
            .map((item1) => {
              const match = selectedServicesFromRecipe.find((item2) => item1.id === item2.service_id);

              // Split install labour special handling
              if ((selectedTab === 'split' || fromSplitEstimate) && item1.id === 10 && match?.facility_id) {
                const facilityService = (servicesRes?.data?.otherInstallationSplitInstallLabour || []).find(
                  (facilityItem) => facilityItem.facility_id == match.facility_id
                );

                if (facilityService) {
                  return {
                    ...facilityService,
                    service_id: match.id,
                    quantity: match.quantity,
                    facility_id: match.facility_id,
                    facility_name: match.facility_name || facilityService.sourceInstallation,
                  };
                }
              }

              return {
                ...item1,
                ...(match
                  ? {
                      service_id: match.id,
                      quantity: match.quantity,
                      price: item1?.price ? item1?.price : 0,
                      facility_id: match.facility_id || null,
                      facility_name: match.facility_name || null,
                    }
                  : {}),
              };
            })
        );
      } else {
        setSelectedServices([]);
      }
    } catch (error) {
      console.error('Error loading split formula selections:', error);
    } finally {
      setMaterialsLoading(false);
      setServicesLoading(false);
    }
  };

  const fetchServiceData = ({ page = servicesPage, limit = servicesRowsPerPage, searchText = debouncedSearch, loadSelected = true, isAppend = false } = {}) => {
    setServicesLoading(true)
    try {
      axios.post(`${REST_API_END_POINT}recipe/get-all-services-optimized`, {
        userId: user.user_id,
        params,
        page: Number(page) + 1,
        limit,
        search: searchText
      })
      .then((response) => {
        let data= response.data.results
        // const productListData =data.filter(row=>row.inhouse===1)
        const productListData =data //.filter(row=>row.inhouse !==2)
        let selectedProducts =[]
        const allPayouts = response.data.allPayOut
        if(loadSelected && response.data.selectedMaterials.length>0){
          let services=
          selectedProducts = response.data.selectedMaterials[0]?.services
          // setRecipeName(response.data.selectedMaterials[0]?.name)
        }
        // if (allPayouts?.length > 0) {
        //   let totalPayOut = allPayouts?.reduce((acc, curr) => acc + curr.amount, 0)
        //   // console.log("######################Payentet", totalPayOut);
        //   setTotalPayOut(allPayouts?.reduce((acc, curr) => acc + curr.amount, 0))
        // }

        if (productListData) {
          const activeServicesList = productListData?.filter((item) => item.status == 1);
          // Sorting is now handled by backend for consistency in infinite scroll
          setServiceList((prev) => {
            if (!isAppend) return activeServicesList;
            const existingIds = new Set(prev.map(p => p.id));
            const newServices = activeServicesList.filter(p => !existingIds.has(p.id));
            return [...prev, ...newServices];
          });
          setHasMoreServices(productListData.length === limit);
        }
        setServicesTotalCount(Number(response?.data?.totalCount || 0));
        
        // Store otherInstallationSplitInstallLabour data (only for split formulas)
        if ((selectedTab === 'split' || fromSplitEstimate) && response.data?.otherInstallationSplitInstallLabour) {
          console.log('Setting otherInstallationSplitInstallLabour:', response.data.otherInstallationSplitInstallLabour);
          setOtherInstallationSplitInstallLabour(response.data.otherInstallationSplitInstallLabour)
        } else if (selectedTab === 'split' || fromSplitEstimate) {
          console.log('No otherInstallationSplitInstallLabour data found in response for split formula');
        }
        
        // console.log("XHznnn",selectedProducts);
        if (loadSelected && response.data.selectedMaterials[0]?.services?.length) {
          const selectedServiceProducts = response?.data?.selectedServiceProducts || [];
          const selectedServiceBase = selectedServiceProducts.length > 0 ? selectedServiceProducts : productListData;
          // console.log("XHznnn",selectedProducts);
          
          // Get the otherInstallationSplitInstallLabour data directly from response for immediate use
          const otherInstallationData = response.data?.otherInstallationSplitInstallLabour || [];
          
          setSelectedServices(selectedServiceBase.filter(item1 =>
            selectedProducts.some(item2 => item1.id === item2.service_id)
          ).map(item1 => {
            let match = selectedProducts.find(item2 => item1.id === item2.service_id);
            // console.log("#########Nush123",item1.price);
            
            // For split formulas and service ID 10, use the facility-specific data
            if ((selectedTab === 'split' || fromSplitEstimate) && item1.id === 10 && match?.facility_id) {
              console.log('Loading service ID 10 for split formula with facility_id:', match.facility_id);
              console.log('Available otherInstallationSplitInstallLabour data:', otherInstallationData);
              
              // Find the facility-specific service data
              const facilityService = otherInstallationData.find(
                facilityItem => facilityItem.facility_id == match.facility_id
              );
              
              console.log('Found facility service:', facilityService);
              
              if (facilityService) {
                return {
                  ...facilityService,
                  service_id: match.id,
                  quantity: match.quantity,
                  facility_id: match.facility_id,
                  facility_name: match.facility_name || facilityService.sourceInstallation
                };
              } else {
                console.log('No facility service found, using default service data');
              }
            }
            
            return { 
              ...item1, 
              ...(match ? { 
                service_id: match.id, 
                quantity: match.quantity, 
                price: item1?.price ? item1?.price : 0,
                facility_id: match.facility_id || null,
                facility_name: match.facility_name || null
              } : {}) 
            };
          }))
        }
      }).catch((error) => {
        console.error("Error fetching data:", error);
      }).finally(() => {
        setServicesLoading(false);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
      setServicesLoading(false);
    }finally{
    }
  }

  console.log("XHznnn122222222",selectedProjects);
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop <= clientHeight + 100) {
      if (currentTab === 'Materials' && !materialsLoading && hasMoreMaterials) {
        setMaterialsLoading(true);
        setMaterialsPage((prev) => prev + 1);
      } else if (currentTab === 'Services' && !servicesLoading && hasMoreServices) {
        setServicesLoading(true);
        setServicesPage((prev) => prev + 1);
      }
    }
  };

  const handleProjectClick = (project) => {
    setSelectedProjects(prevSelectedProjects => [...prevSelectedProjects, project]);
  };

  const handleServiceClick = (project) => {
    // Check if service ID is 10 (install labor service) and it's a split formula (type 3)
    if (project.id === 10 && (selectedTab === 'split' || fromSplitEstimate)) {
      setPendingService(project);
      setFacilityPopupOpen(true);
    } else {
      setSelectedServices(prevSelectedProjects => [...prevSelectedProjects, project]);
      setHasRecipeChanges(true);
    }
  };

  const handleFacilitySelection = (selectedFacility) => {
    console.log('Facility selected:', selectedFacility);
    console.log('Pending service:', pendingService);
    console.log('Available installation labor data:', otherInstallationSplitInstallLabour);
    
    if (selectedFacility && pendingService) {
      // Check if we have the installation labor data
      if (otherInstallationSplitInstallLabour && otherInstallationSplitInstallLabour.length > 0) {
        // Filter and get install labor service for the selected facility
        console.log('Looking for facility_id:', selectedFacility.id);
        console.log('Available facility_ids in data:', otherInstallationSplitInstallLabour.map(item => item.facility_id));
        const matchedInstallLabour = otherInstallationSplitInstallLabour.find(
          item => item.facility_id == selectedFacility.id
        );
        
        console.log('Matched install labour for facility:', matchedInstallLabour);
        
        if (matchedInstallLabour) {
          // Create service object using the matched installation labor data
          const facilityService = {
            id: matchedInstallLabour.id,
            name: matchedInstallLabour.name,
            cost: matchedInstallLabour.cost,
            total_cost: matchedInstallLabour.total_cost,
            markup: matchedInstallLabour.markup,
            facility_id: selectedFacility.id,
            facility_name: selectedFacility.label,
            sourceInstallation: matchedInstallLabour.sourceInstallation,
            sourceInstallationId: matchedInstallLabour.sourceInstallationId,
            quantity: 1,
            // Include other relevant fields from the matched data
            service_type: matchedInstallLabour.service_type,
            quickbookId: matchedInstallLabour.quickbookId,
            avatarUrl: matchedInstallLabour.avatarUrl,
            makeAsTask: matchedInstallLabour.makeAsTask,
            makeInstallCard: matchedInstallLabour.makeInstallCard
          };
          
          console.log('Adding facility service from matched installation labor:', facilityService);
          
          // Add to selected services
          setSelectedServices(prevSelectedServices => [...prevSelectedServices, facilityService]);
          setHasRecipeChanges(true);
        } else {
          // If no specific facility data found, add service with facility info but default cost
          const facilityService = {
            ...pendingService,
            facility_id: selectedFacility.id,
            facility_name: selectedFacility.label,
            install_labour_cost: pendingService.cost || 0, // Use default service cost
            quantity: 1
          };
          
          console.log('Adding facility service with default cost (no match found):', facilityService);
          
          setSelectedServices(prevSelectedServices => [...prevSelectedServices, facilityService]);
          setHasRecipeChanges(true);
        }
      } else {
        // If no installation labor data available, add service with facility info but default cost
        const facilityService = {
          ...pendingService,
          facility_id: selectedFacility.id,
          facility_name: selectedFacility.label,
          install_labour_cost: pendingService.cost || 0, // Use default service cost
          quantity: 1
        };
        
        console.log('Adding facility service with default cost (no data available):', facilityService);
        
        setSelectedServices(prevSelectedServices => [...prevSelectedServices, facilityService]);
        setHasRecipeChanges(true);
      }
    }
    
    // Close popup and reset pending service
    setFacilityPopupOpen(false);
    setPendingService(null);
  };

  useEffect(() => {
    setRecipeNameMirror(initialRecipeName || '')
    setRecipeNameFieldErrors({})
  }, [initialRecipeName])

  const NewUserSchema = Yup.object().shape({
    quantity: Yup.number().min(1, 'Quantity must be at least 1').required('Quantity is required'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      quantity: 1,
      recipe_name: fromSplitEstimate ? formulaName : (recipeId && formulaName ? formulaName : recipeName),
      workflows: null
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setFieldError, setFieldTouched }) => {
      values.recipe_name = recipeNameInputRef.current?.getValue?.() ?? ''
      console.log("################values",values);
      let recipeName=values.recipe_name
      const initialSplitName = formulaName || '';
      const formatTimestamp = () => {
        const now = new Date();
        const pad = (num) => String(num).padStart(2, '0');
        const year = now.getFullYear();
        const month = pad(now.getMonth() + 1);
        const day = pad(now.getDate());
        const hours = pad(now.getHours());
        const minutes = pad(now.getMinutes());
        const seconds = pad(now.getSeconds());
        return `${year}${month}${day}_${hours}${minutes}${seconds}`;
      };
      if (fromSplitEstimate && params && recipeName?.trim().toLowerCase() === initialSplitName?.trim().toLowerCase()) {
        recipeName = `${recipeName} ${formatTimestamp()}`;
      }
      console.log("################values",recipeName);
      try {

       await fakeRequest(500)
        if (fromSplitEstimate && selectedSplitRecipeId && !hasRecipeChanges) {
          const chosen = splitRecipeOptions.find((r) => r.id === selectedSplitRecipeId) || {};
          const cleanName = chosen?.name || recipeName;
          const payload = {
            id: selectedSplitRecipeId,
            recipe_name: cleanName,
            name: cleanName,
            expectedCost: chosen?.expected_cost || chosen?.expectedCost || 0,
            expected_install_labor_cost: chosen?.expected_install_labor_cost || 0,
            type: chosen?.type || 3,
            workflow_id: chosen?.workflow_id || chosen?.workflow || null,
          };
          if (onRecipeCreated) {
            onRecipeCreated(payload);
          }
          setFullscreenOpen(false);
          setSubmitActionLoading(false);
          setSubmitting(false);
          return;
        }
        if (!selectedWorkflow) {
          setFieldError('workflows', 'Please select a Production Workflow.');
          setFieldTouched('workflows', true, false);
          enqueueSnackbar('Please select a Production Workflow.', { variant: 'error' });
          setSubmitActionLoading(false);
          setSubmitting(false);
          return;
        }
        // let expectedProductCost=selectedProjects?.reduce((accumulator, currentValue) => {
        //   return accumulator + (currentValue?.max_price* currentValue?.quantity);
        // }, 0) || 0

        let expectedProductCost = selectedProjects?.reduce((acc, currentValue) => {
          let max_price = Number(currentValue.max_price) || 0;
          let quantity = Number(currentValue.quantity) || 0;
          let convertionQty = Number(currentValue.convertionQty) || 1;
          let retail_markup = Number(currentValue.retail_price) || 0;
        
          let totalWithoutMarkup = 0;
          totalWithoutMarkup = Number(currentValue.initial_max_price || 0) * quantity;
          // if (currentValue.stockType == 1 || currentValue.unit == 4) {
          //   totalWithoutMarkup = Number(currentValue.initial_max_price || 0) * quantity;
          // } else {
          //   totalWithoutMarkup = max_price * convertionQty;
          // }
          return acc + totalWithoutMarkup;
        }, 0) || 0;

        let expectedServiceCost=selectedServices?.reduce((accumulator, currentValue) => {
          // if (currentValue.id == 10) return accumulator;
          const serviceCost = ((selectedTab === 'split' || fromSplitEstimate) && currentValue.id === 10) ? currentValue?.total_cost : currentValue?.cost;
          return accumulator + (serviceCost* currentValue?.quantity);
        }, 0) || 0

        let expectedInstallLaborCost=selectedServices?.reduce((accumulator, currentValue) => {
          if(currentValue.id !== 10) return accumulator;
          const serviceCost = (selectedTab === 'split' || fromSplitEstimate) ? currentValue?.total_cost : currentValue?.cost;
          return accumulator + (serviceCost* currentValue?.quantity);
        }, 0) || 0

        let expectedTotalServiceCost=selectedServices?.reduce((accumulator, currentValue) => {
          console.log('expectedTotalServiceCost---currentValue---',currentValue);
          if (currentValue.id == 10) return accumulator;
          return accumulator + (currentValue?.total_cost* currentValue?.quantity);
        }, 0) || 0
        // let totalRetailMarkUp =selectedProjects?.reduce((accumulator, currentValue) => {
        //   return accumulator + (currentValue?.retail_price);
        // }, 0).toFixed(2)

        let expectedProductCostWithMarkup = (() => {
          let totalCost = 0;
        
          selectedProjects?.forEach((currentValue) => {
            const quantity = Number(currentValue.quantity) || 0;
            totalCost += retailProductLineTotal(currentValue.initial_max_price, quantity, currentValue.retail_price);
          });
        
          return totalCost.toFixed(2);
        })();

        let expectedServiceCostWithMarkup = (() => {
          let totalCost = 0;
        
          selectedServices?.forEach((currentValue) => {
            if (currentValue.id == 10) return;
            totalCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
          });
        
          return totalCost.toFixed(2); // Format the final result
        })();

        let expectedInstallLaborCostWithMarkup = (() => {
          let totalCost = 0;
          
          selectedServices?.forEach((currentValue) => {
            if(currentValue.id !== 10) return;
            totalCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
          });
        
          return totalCost.toFixed(2); // Format the final result
        })();

        let expectedCostWithMarkup =parseFloat(Number(expectedProductCostWithMarkup) + Number(expectedServiceCostWithMarkup) + Number(expectedInstallLaborCostWithMarkup)).toFixed(2)

        let expectedCost = (selectedTab === 'split' || fromSplitEstimate) ? (expectedProductCost + expectedServiceCost - expectedInstallLaborCost).toFixed(2) : (expectedProductCost + expectedServiceCost).toFixed(2)
        const values = selectedProjects.map(project => ({
          ...(project.product_id ? { id: project.product_id } : {}),
          productId: project.id,
          ing_name: project.name,
          projectId: id,
          quantity: project.quantity,
          unitPrice: project.max_price,
          total: (Number(project.max_price) * project.quantity),
          stockType: project.stockType,
          width: project.width,
          convertionUnit: project.convertionUnit,
          convertionQty: project.convertionQty,
        }))
        console.log('selectedServices----',selectedServices);
        const services = selectedServices.map(project => ({
          ...(project.service_id ? { id: project.service_id } : {}),
          serviceId: project.id,
          ing_name: project.name,
          projectId: id,
          quantity: project.quantity,
          unitPrice: (selectedTab === 'split' || fromSplitEstimate) && project.id === 10 ? project.total_cost : project.cost,
          total: (selectedTab === 'split' || fromSplitEstimate) && project.id === 10 ? (Number(project.total_cost) * project.quantity) : (Number(project.cost) * project.quantity),
          facility_id: project.facility_id || null
        }))
        console.log('expectedddddddddd expectedServiceCost', expectedServiceCost)
        console.log('expectedddddddddd expectedInstallLaborCost', expectedInstallLaborCost)
        console.log('expectedddddddddd expectedTotalServiceCost', expectedTotalServiceCost)
        console.log('expectedddddddddd expectedProductCost', expectedProductCost)
        console.log('expectedddddddddd expectedProductCostWithMarkup', expectedProductCostWithMarkup)
        console.log('expectedddddddddd expectedServiceCostWithMarkup', expectedServiceCostWithMarkup)
        console.log('expectedddddddddd expectedCostWithMarkup', expectedCostWithMarkup)
        console.log('expectedddddddddd expectedInstallLaborCostWithMarkup', expectedInstallLaborCostWithMarkup)
        console.log('expectedddddddddd expectedCost', expectedCost)
        
        // return; // Prevent API calls - just for testing calculations
  if(params){
          const nameOrDescription = formulaView === 'description' ? 1 : 0;
          const isSplit = (selectedTab === 'split' || fromSplitEstimate) ? true : false
          axios.post(`${REST_API_END_POINT}recipe/update-recipe`, { userId: user.user_id,services, values,recipeName,params,expectedCost,expectedProductCost,expectedServiceCost,expectedTotalServiceCost,expectedProductCostWithMarkup,expectedServiceCostWithMarkup,expectedCostWithMarkup,expectedInstallLaborCost,expectedInstallLaborCostWithMarkup,isSplit,nameOrDescription,formulaView, isSplitEdited: fromSplitEstimate ? 1 : 0,selectedWorkflow,previosWorkflowId }, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            if (response.data.status === 1) {
              if(response?.data?.isWorfkflowAutoGenerated){
                enqueueSnackbar("A Worflow Added Successfully", { variant: 'success' });
              }
              enqueueSnackbar(response.data.message, { variant: 'success' });
              setHasRecipeChanges(false);
              
              // Close fullscreen dialog if open
              setFullscreenOpen(false);
              
              // // Show catalog confirmation dialog if not fromSplitEstimate
              // if (!fromSplitEstimate && !formulaTab) {
              // If editing from modal (recipeId provided and onRecipeCreated exists), call callback instead of navigating
              if (recipeId && onRecipeCreated) {
                // Update recipes list if setRecipes is available
                if (setRecipes && response.data.recipes) {
                  setRecipes(response.data.recipes);
                  setAllRecipes(response.data.recipes || []);
                }
                
                // Prepare updated recipe data
                const updatedRecipe = response.data.recipe;
                const updatedRecipeData = {
                  id: updatedRecipe?.id || recipeId,
                  recipe_name: updatedRecipe?.name || recipeName,
                  name: updatedRecipe?.name || recipeName,
                  type: updatedRecipe?.type || (selectedTab === "production" ? 1 : selectedTab === "traffic" ? 2 : selectedTab === "estimate" ? 4 : 3),
                  expectedCost: updatedRecipe?.expected_cost || 0,
                  expected_install_labor_cost: updatedRecipe?.expected_install_labor_cost || 0,
                  name_or_description: updatedRecipe?.name_or_description || 1,
                  expected_material_cost_with_markup: updatedRecipe?.expected_material_cost_with_markup || 0,
                  expected_service_cost_with_markup: updatedRecipe?.expected_service_cost_with_markup || 0,
                  install_labour_cost_with_markup: updatedRecipe?.install_labour_cost_with_markup || 0,
                  services: updatedRecipe?.services || [],
                  workflow_id: updatedRecipe?.workflow_id || null,
                };
                
                // Call callback with updated data
                onRecipeCreated(updatedRecipeData);
                setSubmitActionLoading(false);
              } else if (!fromSplitEstimate && !formulaTab) {
                if (AddCatalogPermission) {
                  setSavedRecipeData({
                    id: response.data.recipe?.id || params,
                    name: recipeName
                  });
                  setOpenCatalogConfirmation(true);
                } else {
                  setSubmitActionLoading(false);
                  navigate(PATH_DASHBOARD.products.recipe, { state: { tab: selectedTab,listPage: listPage,rowsPerPage: rowsPerPage,scrollToProductId: params } });
                }
              } else {
                setSubmitActionLoading(false);
                navigate(PATH_DASHBOARD.products.recipe, { state: { tab: selectedTab,listPage: listPage,rowsPerPage: rowsPerPage,scrollToProductId: params } });
              }
            } else if (response.data.status === 0) {
              setSubmitActionLoading(false);
              enqueueSnackbar(response.data.message, { variant: 'error' });
  
            }
  
            if (!recipeId || !onRecipeCreated) {
              const showingCatalogDialog = !fromSplitEstimate && !formulaTab && AddCatalogPermission;
              if (!showingCatalogDialog) {
                if (currentTab === 'Materials') {
                  fetchData();
                } else if (currentTab === 'Services') {
                  fetchServiceData();
                }
              }
            }
            
          }).catch((error) => {
            console.error(error);
            setSubmitActionLoading(false);
  
          })
        }
        else{
          let type = selectedTab === "production" ? 1 : selectedTab === "traffic" ? 2 : selectedTab === "estimate" ? 4 : 3
          axios.post(`${REST_API_END_POINT}recipe/add-recipe`, { userId: user.user_id, values,services,recipeName,expectedCost,expectedProductCost,expectedServiceCost,expectedTotalServiceCost,expectedProductCostWithMarkup,expectedServiceCostWithMarkup,expectedCostWithMarkup,type,expectedInstallLaborCost,expectedInstallLaborCostWithMarkup,isSplitEdited: fromSplitEstimate ? 1 : 0,selectedWorkflow }, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            if (response.data.status === 1) {
              if(response?.data?.isWorfkflowAutoGenerated){
                enqueueSnackbar("A Worflow Added Successfully", { variant: 'success' });
              }
              enqueueSnackbar(response.data.message, { variant: 'success' });
              setHasRecipeChanges(false);
              
              // Close fullscreen dialog if open
              setFullscreenOpen(false);
              
              if ((fromSplitEstimate || formulaTab) && onRecipeCreated) {
                // Call the callback with the new recipe data
                setRecipes(response?.data?.recipes)
                setAllRecipes(response?.data?.recipes || []);
                const newRecipe = response?.data?.recipe
                console.log('newRecipe---', newRecipe)
                const newRecipeData = {
                  id: newRecipe?.id,
                  recipe_name: newRecipe?.name,
                  name: newRecipe?.name,
                  type: type,
                  expectedCost: newRecipe?.expected_cost ,
                  expected_install_labor_cost: newRecipe?.expected_install_labor_cost || 0,
                  workflow_id: newRecipe?.workflow_id || null,
                };
                console.log('newRecipeData', newRecipeData)
                onRecipeCreated(newRecipeData);
                setSubmitActionLoading(false);
              } else if (!fromSplitEstimate && !formulaTab) {
                if (AddCatalogPermission) {
                  setSavedRecipeData({
                    id: response.data.recipe?.id,
                    name: recipeName
                  });
                  setOpenCatalogConfirmation(true);
                } else {
                  const newRecipeId = response.data.recipe?.id;
                  setSubmitActionLoading(false);
                  navigate(PATH_DASHBOARD.products.recipe, { state: { tab: selectedTab,listPage: listPage,rowsPerPage: rowsPerPage,scrollToProductId: newRecipeId } });
                }
              }
            } else if (response.data.status === 0) {
              setSubmitActionLoading(false);
              enqueueSnackbar(response.data.message, { variant: 'error' });
  
            }
            const showingCatalogDialog = !fromSplitEstimate && !formulaTab && AddCatalogPermission;
            if (!showingCatalogDialog) {
              if (currentTab === 'Materials') {
                fetchData();
              } else if (currentTab === 'Services') {
                fetchServiceData();
              }
            }
          }).catch((error) => {
            console.error(error);
            setSubmitActionLoading(false);
  
          })
        }
       

        setSubmitting(false);
      } 
      catch (error) {
        console.error(error);
        setSubmitActionLoading(false);
      }

    }
  });
 
  const { errors, touched, handleSubmit, isSubmitting, getFieldProps, setFieldValue, setFieldError, setFieldTouched, values } = formik;

  const handleRecipeFormSubmit = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (submitActionLoading) return
    const name = recipeNameInputRef.current?.getValue?.() ?? ''
    const textErrs = {}
    if (!name.trim()) {
      textErrs.recipe_name = 'Product Formula Name is required.'
    } else if (name.length > FORMULA_NAME_MAX_LENGTH) {
      textErrs.recipe_name = `Product Formula Name cannot exceed ${FORMULA_NAME_MAX_LENGTH} characters.`
    }
    setRecipeNameFieldErrors(textErrs)
    if (Object.keys(textErrs).length > 0) {
      return
    }
    if (!selectedWorkflow) {
      setFieldError('workflows', 'Please select a Production Workflow.')
      setFieldTouched('workflows', true, false)
      return
    }
    // setSubmitActionLoading(true)
    // handleSubmit(e)
    if (fromAddProductsEdit && recipeId) {
      setOpenSaveOriginalConfirm(true);
      return;
    }

    setSubmitActionLoading(true);
    handleSubmit(e);
  }

  const handleConfirmSaveOriginal = () => {
    setOpenSaveOriginalConfirm(false);
    setSubmitActionLoading(true);
    formik.submitForm();
  };
  
  const handleCancelSaveOriginal = () => {
    setOpenSaveOriginalConfirm(false);
  };
  
  const handleSaveCopyFromWarning = () => {
    setOpenSaveOriginalConfirm(false);
    handleSaveAsCopy();
  };

  const searchTermLower = useMemo(() => normalizeText(debouncedSearch), [debouncedSearch]);
  const filterTermLower = useMemo(() => normalizeText(debouncedFilterName), [debouncedFilterName]);

  const filteredServiceCards = useMemo(() => {
    return serviceList || [];
  }, [serviceList]);

  const filteredProductCards = useMemo(() => {
    return productList || [];
  }, [productList]);

  const selectedServiceIds = useMemo(() => {
    return new Set((selectedServices || []).map((item) => item.id));
  }, [selectedServices]);

  const sortedCatalogTypeOptions = useMemo(() => {
    return [...catalogTypeOptions].sort((a, b) => alphanumericCompare(a?.label || '', b?.label || ''));
  }, []);

  const sortedFacilityTypes = useMemo(() => {
    return [...(filteredOtherFacilityTypes || [])].sort((a, b) => alphanumericCompare(a?.label || '', b?.label || ''));
  }, []);

  const [isSaveCopyLoading, setIsSaveCopyLoading] = useState(false);

  const handleSaveAsCopy = async () => {
    try {
      if (!recipeId) {
        enqueueSnackbar('Recipe id is missing for saving as copy', { variant: 'error' });
        return;
      }

      setIsSaveCopyLoading(true);

      // Decide whether to copy existing recipe as-is or create a new one from current (edited) data
      const initialNameForCompare = (
        fromSplitEstimate ? formulaName : recipeId && formulaName ? formulaName : recipeName || ''
      ).trim()
      const currentName = (recipeNameInputRef.current?.getValue?.() ?? '').trim()
      const nameChangedFromInitial = currentName !== initialNameForCompare
      const hasFormChanges = formik.dirty || nameChangedFromInitial
      const originalName = (formulaName || '').trim();
      const editedName = currentName;
      const isNameChanged = !!editedName && editedName !== originalName;
      // Only send a name to backend if user actually changed it;
      // otherwise let backend generate "base-copy", "base-copy(2)", etc.
      const finalCopyName = isNameChanged ? editedName : null;

      // Frontend guard: if the user-changed name already exists in current recipes, block early
      if (finalCopyName && allRecipes.length) {
        const existsOnClient = allRecipes.some((r) => {
          const n = (r.name || r.recipe_name || '').trim().toLowerCase();
          return n && n === finalCopyName.trim().toLowerCase();
        });

        if (existsOnClient) {
          enqueueSnackbar(`Product Formula "${finalCopyName}" already exists.`, {
            variant: 'error',
          });
          return;
        }
      }

      let response;

      if (!hasFormChanges && !hasRecipeChanges) {
        // No changes: use backend shortcut to copy existing formula as-is
        const payload = {
          id: recipeId,
          userId: user.user_id,
        };
        if (finalCopyName) {
          payload.name = finalCopyName;
        }

        response = await axios.post(
          `${REST_API_END_POINT}recipe/save-recipe-as-copy`,
          payload,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
      } else {
        if (!selectedWorkflow) {
          enqueueSnackbar('Please select a Production Workflow.', { variant: 'error' });
          setFieldError('workflows', 'Please select a Production Workflow.');
          setFieldTouched('workflows', true, false);
          return;
        }
        // Changes present: create a new recipe using current edited data
        const recipeName = ((recipeNameInputRef.current?.getValue?.() ?? formulaName) || '').trim();
        const copyName =
          finalCopyName ||
          (recipeName ? `${recipeName}-copy` : `${formulaName || 'Recipe'}-copy`);

        // Reuse the same calculations as in onSubmit to build payload
        let expectedProductCost = selectedProjects?.reduce((acc, currentValue) => {
          let quantity = Number(currentValue.quantity) || 0;
          let totalWithoutMarkup = Number(currentValue.initial_max_price || 0) * quantity;
          return acc + totalWithoutMarkup;
        }, 0) || 0;

        let expectedServiceCost = selectedServices?.reduce((accumulator, currentValue) => {
          const serviceCost = ((selectedTab === 'split' || fromSplitEstimate) && currentValue.id === 10)
            ? currentValue?.total_cost
            : currentValue?.cost;
          return accumulator + (serviceCost * currentValue?.quantity);
        }, 0) || 0;

        let expectedInstallLaborCost = selectedServices?.reduce((accumulator, currentValue) => {
          if (currentValue.id !== 10) return accumulator;
          const serviceCost = (selectedTab === 'split' || fromSplitEstimate)
            ? currentValue?.total_cost
            : currentValue?.cost;
          return accumulator + (serviceCost * currentValue?.quantity);
        }, 0) || 0;

        let expectedTotalServiceCost = selectedServices?.reduce((accumulator, currentValue) => {
          if (currentValue.id == 10) return accumulator;
          return accumulator + (currentValue?.total_cost * currentValue?.quantity);
        }, 0) || 0;

        let expectedProductCostWithMarkup = (() => {
          let totalCost = 0;
          selectedProjects?.forEach((currentValue) => {
            const quantity = Number(currentValue.quantity) || 0;
            totalCost += retailProductLineTotal(currentValue.initial_max_price, quantity, currentValue.retail_price);
          });
          return totalCost.toFixed(2);
        })();

        let expectedServiceCostWithMarkup = (() => {
          let totalCost = 0;
          selectedServices?.forEach((currentValue) => {
            if (currentValue.id == 10) return;
            totalCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
          });
          return totalCost.toFixed(2);
        })();

        let expectedInstallLaborCostWithMarkup = (() => {
          let totalCost = 0;
          selectedServices?.forEach((currentValue) => {
            if (currentValue.id !== 10) return;
            totalCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
          });
          return totalCost.toFixed(2);
        })();

        let expectedCostWithMarkup = parseFloat(
          Number(expectedProductCostWithMarkup) +
          Number(expectedServiceCostWithMarkup) +
          Number(expectedInstallLaborCostWithMarkup)
        ).toFixed(2);

        let expectedCost = (
          (selectedTab === 'split' || fromSplitEstimate)
            ? (expectedProductCost + expectedServiceCost - expectedInstallLaborCost)
            : (expectedProductCost + expectedServiceCost)
        ).toFixed(2);

        const valuesPayload = selectedProjects.map(project => ({
          ...(project.product_id ? { id: project.product_id } : {}),
          productId: project.id,
          ing_name: project.name,
          projectId: id,
          quantity: project.quantity,
          unitPrice: project.max_price,
          total: (Number(project.max_price) * project.quantity),
          stockType: project.stockType,
          width: project.width,
          convertionUnit: project.convertionUnit,
          convertionQty: project.convertionQty,
        }));

        const servicesPayload = selectedServices.map(project => ({
          ...(project.service_id ? { id: project.service_id } : {}),
          serviceId: project.id,
          ing_name: project.name,
          projectId: id,
          quantity: project.quantity,
          unitPrice: (selectedTab === 'split' || fromSplitEstimate) && project.id === 10 ? project.total_cost : project.cost,
          total: (selectedTab === 'split' || fromSplitEstimate) && project.id === 10
            ? (Number(project.total_cost) * project.quantity)
            : (Number(project.cost) * project.quantity),
          facility_id: project.facility_id || null
        }));

        let type = selectedTab === "production" ? 1 : selectedTab === "traffic" ? 2 : selectedTab === "estimate" ? 4 : 3;

        response = await axios.post(
          `${REST_API_END_POINT}recipe/add-recipe`,
          {
            userId: user.user_id,
            values: valuesPayload,
            services: servicesPayload,
            recipeName: copyName,
            expectedCost,
            expectedProductCost,
            expectedServiceCost,
            expectedTotalServiceCost,
            expectedProductCostWithMarkup,
            expectedServiceCostWithMarkup,
            expectedCostWithMarkup,
            type,
            expectedInstallLaborCost,
            expectedInstallLaborCostWithMarkup,
            selectedWorkflow
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
      }

      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message || 'Product Formula saved as copy successfully', {
          variant: 'success',
        });

        // Close fullscreen dialog if open
        setFullscreenOpen(false);

        const recipes = response.data.recipes || [];
        const recipe = response.data.recipe || null;

        if (setRecipes && recipes.length) {
          setRecipes(recipes);
          setAllRecipes(recipes || []);
        }

        if (recipe && onRecipeCreated) {
          const newRecipeData = {
            id: recipe?.id || recipe?.recipe_id,
            recipe_name: recipe?.name,
            name: recipe?.name,
            type: recipe?.type || (formulaTab === 'production' ? 1 : formulaTab === 'traffic' ? 2 : 3),
            expected_cost: recipe?.expected_cost || 0,
            expected_install_labor_cost: recipe?.expected_install_labor_cost || 0,
            expected_material_cost_with_markup: recipe?.expected_material_cost_with_markup || 0,
            expected_service_cost_with_markup: recipe?.expected_service_cost_with_markup || 0,
            install_labour_cost_with_markup: recipe?.install_labour_cost_with_markup || 0,
            services: recipe?.services || [],
            workflow_id: recipe?.workflow_id || null,
          };

          onRecipeCreated(newRecipeData);
        }
      } else {
        enqueueSnackbar(response.data.message || 'Failed to save Product Formula as copy', {
          variant: 'error',
        });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error while saving Product Formula as copy', { variant: 'error' });
    } finally {
      setIsSaveCopyLoading(false);
    }
  };


  const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  // Auto-save confirmation dialog handlers — only used by in-app Back button
  const handleBackConfirmYes = async () => {
    setOpenBackConfirm(false);
    try {
      await formik.submitForm();
      // Navigation will happen in onSubmit success handler
    } catch (error) {
      console.error('Auto-save failed:', error);
      // Still navigate back on error
      navigate(PATH_DASHBOARD.products.recipe, { state: { tab: selectedTab, listPage: listPage, rowsPerPage: rowsPerPage, scrollToProductId: params } });
    }
  };

  const handleBackConfirmNo = () => {
    setOpenBackConfirm(false);
    try {
      sessionStorage.removeItem(RECIPE_EDIT_STATE_KEY);
    } catch (_) { /* ignore */ }
    navigate(PATH_DASHBOARD.products.recipe, { state: { tab: selectedTab, listPage: listPage, rowsPerPage: rowsPerPage, scrollToProductId: params } });
  };

  const handleBackButtonClick = (e) => {
    e.preventDefault();
    setOpenBackConfirm(true);
  };

  return (

    <Page title={`Product Formula | ${COMPANY_NAME}`} sx={{height:'70vh'}} >
        <Container sx={{height:'85vh',overflow:'scroll',overflowX:'hidden',overflowY:'scroll',}}>
          {
            (fromSplitEstimate || selectedTab === "estimate" || fromAddProductsEdit) ? '' : 
          <Button
            variant="outlined"
            // type="submit"
            // component={RouterLink}
            // // to={PATH_DASHBOARD.products.recipe}
            // to={{
            //   pathname: PATH_DASHBOARD.products.recipe,
            // }}
            // state={{ tab: selectedTab,listPage: listPage,rowsPerPage: rowsPerPage,scrollToProductId: params }}
           onClick={handleBackButtonClick}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back to {selectedTab === "production" ? "Production Formulas" : selectedTab === "traffic" ? "Traffic Formulas" : selectedTab === "estimate" ? "Estimate Formulas" : "Split Formulas"}
          </Button>
          }
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
          <HeaderBreadcrumbs


            heading={selectedTab === "production" ? "Production Formula" : selectedTab === "traffic" ? "Traffic Formula" : selectedTab === "estimate" ? "Estimate Formula" : "Split Formula"}
          />
           {/* Name / Description Switch */}
      {currentTab === 'Materials' && (
      <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={1}>
        <Typography
          variant="body2"
          sx={{ fontWeight: formulaView === 'name' ? 600 : 400 }}
        >
          Name
        </Typography>

        <Switch
          size="small"
          checked={formulaView === 'description'}
          onChange={(e) =>
            setFormulaView(e.target.checked ? 'description' : 'name')
          }
        />

        <Typography
          variant="body2"
          sx={{ fontWeight: formulaView === 'description' ? 600 : 400 }}
        >
          Description
        </Typography>
      </Stack>
      )}
      </Stack>


          <Grid container spacing={1}>
          <Grid item xs={12} sx={{position:'sticky',zIndex:10,top:'-8px'}}>

          <Dialog
  open={openSaveOriginalConfirm}
  onClose={handleCancelSaveOriginal}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle
    sx={{
      color: 'warning.main',
      fontWeight: 700,
      fontSize: '1.25rem',
      pb: 1
    }}
  >
    ⚠ Warning
  </DialogTitle>

  <DialogContent>
    <Box
      sx={{
        backgroundColor: 'warning.lighter',
        border: 1,
        borderColor: 'warning.main',
        borderRadius: 1.5,
        p: 2
      }}
    >
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          color: 'warning.dark',
          mb: 1
        }}
      >
        Saving as Original will overwrite the existing formula.
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: '#524646',
          mb: 1
        }}
      >
        Are you sure you want to make this change?
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: '#2C2C2C'
        }}
      >
        If you want to keep the existing formula unchanged, select
        <Box component="span" sx={{ fontWeight: 700, color: 'primary.main' }}>
          {' '}Save as Copy{' '}
        </Box>
        to create a new Product Formula.
      </Typography>
    </Box>
  </DialogContent>

  <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
    <Button
      onClick={handleCancelSaveOriginal}
      variant="outlined"
      color="inherit"
    >
      Cancel
    </Button>

    {!hideSaveAsCopy && (
      <Button
        onClick={handleSaveCopyFromWarning}
        variant="outlined"
        color="primary"
        startIcon={<FileCopy />}
      >
        Save as Copy
      </Button>
    )}

    <LoadingButton
      onClick={handleConfirmSaveOriginal}
      variant="contained"
      color="warning"
      loading={submitActionLoading}
      startIcon={<Save />}
    >
      Yes, Save as Original
    </LoadingButton>
  </DialogActions>
</Dialog>
        <Dialog open={open} >
          <DialogTitle id="simple-dialog-title">Select Stock Type</DialogTitle>
          <List>
            <Block title="" >
              <RadioGroup  
                defaultValue="1"
                value={String(stockType)}
                onChange={(e) => {
                  setStockType(e.target.value === '1' ? 1 : 2);
                  if(e.target.value === '1'){
                    setConvertionUnit(0);
                  }
                }}
              >
                <FormControlLabel value="1" control={<Radio size="small" />} label="Finished Product" />
                <FormControlLabel value="2" control={<Radio size="small" />} label="Partial Finished Product" />
              </RadioGroup>
              {loading ? (
                <CircularProgress color="primary" variant="indeterminate" />
              ) : partialProducts?.length > 0 && UNITS?.some(u => partialProducts?.some(p => p?.partial_unit === u?.id)) ? (
                stockType === 2 ? (
                  <>
                    <DialogTitle id="simple-dialog-title">Select Conversion Unit</DialogTitle>
                    <RadioGroup
                      value={convertionUnit}
                      onChange={(e,newValue) => {
                        setConvertionUnit(Number(e.target.value))
                      }}
                    >
                      {UNITS
                        // (pendingProject?.unit === 4 
                        //   ? UNITS 
                        //   : UNITS.filter(item => {
                        //       const foundUnit = UNITS.find(u => u.id === pendingProject?.unit);
                        //       return foundUnit ? item.unit_id === foundUnit.unit_id : false;
                        //     })
                        // )
                        ?.filter(u => partialProducts?.some(p => p.partial_unit === u.id)) //  && p.total_qty > 0
                        ?.map(u => (
                          <FormControlLabel key={u.id} value={u.id} control={<Radio size="small" />} label={u.name} />
                        ))}
                    </RadioGroup>
                  </>
                ) : null
              ) : (
                stockType === 2 ? <Typography variant='body1' sx={{ color: 'red' }}>No partial stock found</Typography> : ''
              )}
              <Stack gap={1} direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Button variant='outlined' color='error' sx={{ mt:2 }} onClick={()=>handleClose()}>Close</Button>
                <Button variant='contained' sx={{ mt:2}} disabled={(stockType === 2 && partialProducts?.length <= 0) ? true : false  } onClick={()=>handleSubmitPopUp()}>Submit</Button>
              </Stack>
            </Block>
          </List>
        </Dialog>

         <Dialog fullScreen open={fullscreenOpen}  TransitionComponent={Transition}>
        {/* <AppBar position="relative" sx={{display:"flex",justifyContent:"flex-end"}}>
          <Toolbar>
            <IconButton color="inherit" edge="start" onClick={handleCloseFullscreen}>
              <CloseIcon />
            </IconButton>
           
           
          </Toolbar>

        </AppBar> */}

<AppBar position="relative" mb={1}>
          <Toolbar sx={{ minHeight: '48px !important', py: 0.5 }}>
            <Typography variant="subtitle1" sx={{ flex: 1, ml: 1, fontSize: '1rem' }}>
              Details
            </Typography>
              <CloseIcon onClick={handleCloseFullscreen} sx={{fontSize:'1.8rem',cursor:'pointer'}}/>
          </Toolbar>
        </AppBar>

        <Grid container spacing={0.5}>
          <Grid item  xs={12}>
            {/* Two-column layout: left = Materials/Services tabs, right = details table */}
            <Grid container spacing={1}>
              <Grid item xs={12} md={2.5} sx={{px:1}}>
                {/* Materials / Services tabs and cards (same behaviour as non-fullscreen view) */}
                <Box sx={{ mb: 1 }}>
                  <Tabs
                    value={currentTab}
                    scrollButtons="auto"
                    variant="scrollable"
                    allowScrollButtonsMobile
                    onChange={handleChangeTab}
                    sx={{
                      minHeight: '36px',
                      mb: 0.5,
                      '& .MuiTabs-flexContainer': { gap: 0.5 },
                    }}
                  >
                    {ACCOUNT_TABS.map((tabItem) => (
                      <Tab
                        sx={{ px: 1.5, minHeight: '36px', fontSize: '0.7rem' }}
                        disableRipple
                        key={tabItem.value}
                        label={
                          <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>{capitalCase(tabItem.name)}</Typography>
                        }
                        value={tabItem.value}
                      />
                    ))}
                  </Tabs>
                  {tab ? (
                    <>
                      <JobCostToolbar
                        filterName={search}
                        onFilterName={(event) => setSearch(event.target.value)}
                        currentTab={currentTab}
                      />
                      <Card
                        onScroll={handleScroll}
                        sx={{
                          p: 1,
                          mt: 0.5,
                          height: 'calc(100vh - 200px)',
                          overflowY: 'auto',
                          backgroundColor: 'transparent',
                          background: 'transparent',
                          '&::-webkit-scrollbar': {
                            width: '6px',
                          },
                          '&::-webkit-scrollbar-track': {
                            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                            background: 'rgba(255, 255, 255, 0.1)',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            borderRadius: '4px',
                          },
                        }}
                      >
                        <Grid container spacing={0.5}>
                          {servicesLoading && filteredServiceCards.length === 0 ? Array.from({ length: 12 }).map((_, index) => (
                              <Grid key={`service-skeleton-${index}`} item xs={6} sm={6} md={6}>
                                <Box sx={{ p: 0.5 }}>
                                  <Skeleton variant="rect" height={50} sx={{ borderRadius: 1 }} />
                                </Box>
                              </Grid>
                            )) : filteredServiceCards.map((post, index) => (
                              <Grid key={index} item xs={6} sm={6} md={6}>
                                <Card
                                  onMouseEnter={() => setIsHover(true)}
                                  onMouseLeave={() => setIsHover(false)}
                                  sx={{
                                    minWidth: 80,
                                    borderRadius: 1.5,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    boxShadow: 1,
                                    transition: 'transform 0.2s, box-shadow 0.2s',
                                    cursor: 'pointer',
                                    '&:hover': {
                                      transform: 'scale(1.02)',
                                      boxShadow: 3,
                                    },
                                  }}
                                  onClick={() =>
                                    !selectedServiceIds.has(post.id)
                                      ? handleServiceClick({ ...post, quantity: 1 })
                                      : enqueueSnackbar('Service Already Added', { variant: 'error' })
                                  }
                                >
                                  <Box
                                    sx={{
                                      p: 0.8,
                                      textAlign: 'center',
                                      justifyContent: 'center',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      height: '50px',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      justifyContent={'center'}
                                      alignItems={'center'}
                                      sx={{ height: '100%' }}
                                    >
                                      <Tooltip
                                        title={
                                          <>
                                            <div> {post?.name || ''}</div>
                                          </>
                                        }
                                      >
                                        <Typography
                                          variant="caption"
                                          align="center"
                                          sx={{
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            WebkitLineClamp: 2,
                                            lineHeight: '1.1',
                                            maxHeight: '2.2em',
                                            fontSize: '0.7rem',
                                          }}
                                        >
                                          {/* {formulaView === 'name' ? (
                                            post?.name
                                          ) : (
                                            post?.description
                                          )} */}
                                          {post.name}
                                        </Typography>
                                      </Tooltip>
                                    </Stack>
                                  </Box>
                                </Card>
                              </Grid>
                            ))}
                            {servicesLoading && filteredServiceCards.length > 0 && Array.from({ length: 4 }).map((_, index) => (
                              <Grid key={`service-skeleton-append-${index}`} item xs={6} sm={6} md={6}>
                                <Box sx={{ p: 0.5 }}>
                                  <Skeleton variant="rect" height={50} sx={{ borderRadius: 1 }} />
                                </Box>
                              </Grid>
                            ))}
                        </Grid>
                      </Card>
                    </>
                  ) : (
                    <>
                      <JobCostToolbar
                        filterName={search}
                        onFilterName={(event) => setSearch(event.target.value)}
                        currentTab={currentTab}
                      />
                      <Card
                        onScroll={handleScroll}
                        sx={{
                          p: 1,
                          mt: 0.5,
                          height: 'calc(100vh - 200px)',
                          overflowY: 'auto',
                          backgroundColor: 'transparent',
                          background: 'transparent',
                          '&::-webkit-scrollbar': {
                            width: '6px',
                          },
                          '&::-webkit-scrollbar-track': {
                            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                            background: 'rgba(255, 255, 255, 0.1)',
                          },
                          '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            borderRadius: '4px',
                          },
                        }}
                      >
                        <Grid container spacing={0.5}>
                          {materialsLoading && filteredProductCards.length === 0 ? Array.from({ length: 12 }).map((_, index) => (
                              <Grid key={`material-skeleton-${index}`} item xs={6} sm={6} md={6}>
                                <Box sx={{ p: 0.5 }}>
                                  <Skeleton variant="rect" height={50} sx={{ borderRadius: 1 }} />
                                </Box>
                              </Grid>
                            )) : filteredProductCards.map((post, index) => (
                              <Grid key={index} item xs={6} sm={6} md={6}>
                                <Card
                                  onMouseEnter={() => setIsHover(true)}
                                  onMouseLeave={() => setIsHover(false)}
                                  sx={{
                                    minWidth: 80,
                                    borderRadius: 1.5,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    boxShadow: 1,
                                    transition: 'transform 0.2s, box-shadow 0.2s',
                                    cursor: 'pointer',
                                    '&:hover': {
                                      transform: 'scale(1.02)',
                                      boxShadow: 3,
                                    },
                                  }}
                                  onClick={() => {
                                    handleProductClick(post);
                                  }}
                                >
                                  <Box
                                    sx={{
                                      p: 0.8,
                                      textAlign: 'center',
                                      justifyContent: 'center',
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      height: '50px',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    <Stack
                                      direction={'row'}
                                      justifyContent={'center'}
                                      alignItems={'center'}
                                      sx={{ height: '100%' }}
                                    >
                                      <Tooltip
                                        title={
                                          <>
                                            <div>
                                              <strong>Name:</strong> {post?.name || ''}
                                            </div>
                                            <div>
                                              <strong>Description:</strong> {post?.description || ''}
                                            </div>
                                          </>
                                        }
                                      >
                                        <Typography
                                          variant="caption"
                                          align="center"
                                          sx={{
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                            whiteSpace: 'pre-line',
                                            wordBreak: 'break-word',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            WebkitLineClamp: 2,
                                            lineHeight: '1.1',
                                            maxHeight: '2.2em',
                                            fontSize: '0.7rem',
                                          }}
                                        >
                                          {formulaView === 'name' ? (
                                            post?.name
                                          ) : (
                                            post?.description
                                          )}
                                          {/* {post?.description} */}
                                        </Typography>
                                      </Tooltip>
                                    </Stack>
                                  </Box>
                                </Card>
                              </Grid>
                            ))}
                            {materialsLoading && filteredProductCards.length > 0 && Array.from({ length: 4 }).map((_, index) => (
                              <Grid key={`material-skeleton-append-${index}`} item xs={6} sm={6} md={6}>
                                <Box sx={{ p: 0.5 }}>
                                  <Skeleton variant="rect" height={50} sx={{ borderRadius: 1 }} />
                                </Box>
                              </Grid>
                            ))}
                        </Grid>
                      </Card>
                    </>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} md={9.5} sx={{mt:1}}>
                <FormikProvider value={formik}>
                  <Form noValidate autoComplete="off" onSubmit={handleRecipeFormSubmit}>
                  <Box sx={{ position: 'sticky', top: 0, zIndex: 1, pt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                      {fullscreenOpen && (
                      <Box sx={{ backgroundColor: 'background.paper', p: 1.5, borderRadius: 1 }}>
                      <RecipeFormulaNameTextField
                        ref={recipeNameInputRef}
                        key={`name-fs-${recipeId || 'new'}-${initialRecipeName}`}
                        selectedTab={selectedTab}
                        initialValue={recipeNameMirror || initialRecipeName}
                        onDebouncedName={(v) => {
                          setRecipeNameMirror(v)
                          setRecipeNameFieldErrors((prev) => {
                            const next = { ...prev }
                            if (v.trim() && v.length <= FORMULA_NAME_MAX_LENGTH) {
                              delete next.recipe_name
                            }
                            return next
                          })
                        }}
                        error={Boolean(recipeNameFieldErrors.recipe_name)}
                        helperText={recipeNameFieldErrors.recipe_name || ''}
                      />
                      </Box>
                      )}
                      <Box sx={{ backgroundColor: 'background.paper', p: 1.5, borderRadius: 1 }}>
                      <Autocomplete
                        fullWidth
                        id="combo-box-demo"
                        options={workflows}
                        value={selectedWorkflow}
                        onChange={async (event, newValue) => {
                          setFieldValue('workflows', newValue)
                          if(newValue){
                            setSelectedWorkflow(newValue || null)
                         
                              // Remove services from previously selected workflow when switching
                          if (selectedWorkflow) {
                              const oldRawIds = [
                                ...(selectedWorkflow.allServiceIds ? selectedWorkflow.allServiceIds.split(',') : []),
                                // ...(selectedWorkflow.allSkillIds ? selectedWorkflow.allSkillIds.split(',') : [])
                              ];
                              const oldServiceIds = [...new Set(oldRawIds.map(id => parseInt(id.trim())).filter(id => !isNaN(id)))];
                              if (oldServiceIds.length > 0) {
                                setSelectedServices(prevSelected =>
                                    prevSelected.filter(service => !oldServiceIds.includes(service.id))
                                );
                              }
                          }
              
                            // Auto-select services from workflow's allServiceIds
                            if (newValue) { 
                            const rawIds = [
                              ...(newValue.allServiceIds ? newValue.allServiceIds.split(',') : []),
                              // ...(newValue.allSkillIds ? newValue.allSkillIds.split(',') : [])
                            ];
                           const serviceIds = rawIds.map(id => parseInt(id.trim())).filter(id => !isNaN(id)); 
                            if (serviceIds.length > 0) {
                              try {
                                const res = await axios.post(`${REST_API_END_POINT}recipe/get-all-services-optimized`, {
                                  userId: user.user_id,
                                  params: null,
                                  page: 1,
                                  limit: 200, // Use a high limit
                                  serviceIds: [...new Set(serviceIds)], // Query unique IDs for performance
                                  disablePagination: true
                                });
    
                                const fetchedServices = res?.data?.results || [];
    
                                // 2. Expand fetched services back into duplicates based on the original list
                                const servicesToAdd = serviceIds.map(id => {
                                  const match = fetchedServices.find(s => s.id === id);
                                  return match ? { ...match, quantity: 1 } : null;
                                }).filter(Boolean);

                                if (servicesToAdd.length > 0) {
                                  // 3. Append everything (removed the filter that blocks existing ones)
                                  setSelectedServices(prevSelected => [...prevSelected, ...servicesToAdd]);
                                  setHasRecipeChanges(true);
                                }
                              } catch (e) {
                                console.error('Error fetching workflow services', e);
                              }
                            }
                          }
                        }else{
                          // Remove services associated with the previously selected workflow
                       if (selectedWorkflow) {
                            const rawIds = [
                              ...(selectedWorkflow.allServiceIds ? selectedWorkflow.allServiceIds.split(',') : []),
                              // ...(selectedWorkflow.allSkillIds ? selectedWorkflow.allSkillIds.split(',') : [])
                            ];
                            const serviceIds = [...new Set(rawIds.map(id => parseInt(id.trim())).filter(id => !isNaN(id)))];

                            setSelectedServices(prevSelected =>
                              prevSelected.filter(service => !serviceIds.includes(service.id))
                            );
                            setHasRecipeChanges(true);
                          }

                          setSelectedWorkflow(null)
                        }
                         }}
                        renderInput={(params) => (
                          <TextField {...params} required fullWidth
                            error={Boolean(touched.workflows && errors.workflows)}
                            helperText={touched.workflows && errors.workflows}
                            label="Select a Production Workflow" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}

                      />
                      </Box>
                      {fromSplitEstimate && (
                        <Box sx={{ mb: 2 }}>
                          <Autocomplete
                            options={(splitRecipeOptions || []).sort((a, b) => 
                              alphanumericCompare(a?.name || '', b?.name || '')
                            )}
                            getOptionLabel={(option) => option?.name || ''}
                            value={splitRecipeOptions.find(
                              (option) => option?.name?.toLowerCase() === (recipeNameMirror || '').toLowerCase()
                            ) || null}
                            onChange={(event, newValue) => {
                              if (newValue?.name) {
                                setFieldValue('recipe_name', newValue.name);
                                recipeNameInputRef.current?.setValue?.(newValue.name);
                                setRecipeNameMirror(newValue.name);
                              setSelectedSplitRecipeId(newValue.id || null);
                              setHasRecipeChanges(false);
                                loadSplitFormulaSelections(newValue?.id);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Choose Existing Split Formula"
                                placeholder="Search split formulas"
                                fullWidth
                              />
                            )}
                          />
                        </Box>
                      )}
                      {currentTab === 'Materials' && (
                        <Stack direction="row" alignItems="center" spacing={0.25}>
                      <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: formulaView === 'name' ? 600 : 400 }}>
                        Name
                      </Typography>
                      <Switch
                        size="small"
                        checked={formulaView === 'description'}
                        onChange={(e) => setFormulaView(e.target.checked ? 'description' : 'name')}
                      />
                      <Typography variant="caption" sx={{ fontSize: '0.65rem', fontWeight: formulaView === 'description' ? 600 : 400 }}>
                        Description
                      </Typography>
                    </Stack>
                        )}
                      </Box>
                      <TableContainer 
                      ref={tableContainerRef}
                      sx={{ minWidth: 550, height:'calc(100vh - 350px)', whiteSpace: "nowrap", overflowX: "auto", overflowY: "auto", mt: 1 }}
                      >
                        
                        
                        <Table stickyHeader size="small">
                          <TableHead
                            sx={{ zIndex:999,
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,whiteSpace:'nowrap',
                              '& .MuiTableCell-head': {
                                padding: '6px 8px',
                                fontSize: '0.75rem',
                              }
                            }}
                          >
                            <TableRow>

                              {/* <TableCell align="left">
                          <Typography variant="body1" noWrap>ID</Typography>
                        </TableCell> */}
                           <TableCell align="center" sx={{ padding: '6px 4px !important' }}>
                                <Typography variant="caption" noWrap></Typography>
                              </TableCell>
                                 {/* <TableCell align="center">
                                <Typography variant="body1" noWrap></Typography>
                              </TableCell> */}
                              <TableCell align="center" sx={{ minWidth: '100px' }}>
                                <Typography variant="caption" noWrap sx={{ fontSize: '0.75rem' }}>
                                  {formulaView === 'name' ? 'Name' : 'Description'}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="caption" noWrap sx={{ fontSize: '0.75rem' }}>Quantity</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="caption" noWrap sx={{ fontSize: '0.75rem' }}>Unit Cost</Typography>
                              </TableCell>
                        <Tooltip title="Unit Cost * Quantity">
                        <TableCell align="center">
                          <Typography variant="caption" noWrap sx={{ fontSize: '0.75rem' }}>Sub Total</Typography>
                        </TableCell> 
                        </Tooltip>


                        <TableCell align="center" sx={{ whiteSpace: 'normal', wordBreak: 'break-word',minWidth: '100px', maxWidth: '120px' }}>
                          <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>Retail Markup (%)</Typography>
                        </TableCell>

                        <Tooltip title="(Sub Total * Retail Markup) /100">
                        <TableCell align="center" sx={{ whiteSpace: 'normal', wordBreak: 'break-word',minWidth: '100px', maxWidth: '120px' }}>
                          <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>Retail Amount</Typography>
                        </TableCell>
                        </Tooltip>


                      <Tooltip title="Sub Total + Retail Markup Amount">
                        <TableCell align="center">
                          <Typography variant="caption" noWrap sx={{ fontSize: '0.75rem' }}>Total</Typography>
                        </TableCell>
                        </Tooltip>
                        
                              <TableCell align="center" sx={{ padding: '6px 4px !important' }}>
                                <Typography variant="caption" noWrap></Typography>
                              </TableCell>

                              <TableCell align="center" sx={{ padding: '6px 4px !important' }}>
                                <Typography variant="caption" noWrap></Typography>
                              </TableCell>

                            </TableRow>
                          </TableHead>
                          {/* <Scrollbar
                      sx={{
                        height: '320px',minWidth: 550
                      }}> */}
                          <TableBody sx={{overflowY:'auto',
                            '& .MuiTableCell-body': {
                              padding: '4px 6px',
                              fontSize: '0.75rem',
                            }
                          }}>
                            {selectedProjects
                              ?.filter((selectedProject) => {
                                const labelValue =
                                  formulaView === 'description'
                                    ? selectedProject?.description
                                    : selectedProject?.name;
                                return (
                                  (labelValue || selectedProject?.name || '')
                                    .toLowerCase()
                                    .includes(filterName.toLowerCase())
                                );
                              })
                              .map((selectedProject, index) => {
                              // let unitName = UNITS?.filter((item) => item?.id == selectedProject?.unit);
                              // let newShortUnitName = unitName?.[0]?.short_name || "";
                              // let fullUnitName = unitName?.[0]?.name || "";
                              // let shortUnitName = newShortUnitName;
                              const conversionUnit = selectedProject?.convertion_unit;

                                const selectedUnitId =
                                  Number(selectedProject.stockType) === 1
                                    ? selectedProject?.unit
                                    : conversionUnit != null && Number(conversionUnit) !== 0
                                      ? conversionUnit
                                      : selectedProject?.convertionUnit ?? selectedProject?.unit;

                                const unitName = UNITS?.filter(
                                  (item) => String(item?.id) === String(selectedUnitId)
                                ) || [];
                                let newShortUnitName = unitName?.[0]?.short_name || "";
                                let fullUnitName = unitName?.[0]?.name || "";
                                let shortUnitName = newShortUnitName;

                              let totalWithoutMarkup = 0;
                              let retail_markup = selectedProject?.retail_price || 0;
                              let markup_price = 0;
                              let Total = 0;
                              let calculatedPrice = 0;
                              let remainingStockQty = 0;
                              let qtyAfterConversion = 0;
                              let convertionQty = 0
                              const selectedUnit = UNITS.find(unit => unit.id === selectedProject.convertionUnit);
                              const initialUnit = UNITS.find(unit => unit.id === selectedProject.unit);

                              if (true) {
                              // if (selectedProject.stockType == 1 || selectedProject?.unit == 4) {
                                selectedProject.max_price = selectedProject.initial_max_price || 0;
                                totalWithoutMarkup = (Number(selectedProject.initial_max_price) * (selectedProject.quantity));
                                markup_price = (totalWithoutMarkup * retail_markup) / 100;
                                Total = totalWithoutMarkup + markup_price;
                                qtyAfterConversion = selectedProject.quantity || 0;
                              }

                              // Apply `.toFixed(2)` only at the end for display
                              totalWithoutMarkup = totalWithoutMarkup.toFixed(2);
                              markup_price = markup_price.toFixed(2);
                              Total = Total.toFixed(2);

                       
                              return(
                              <TableRow
                              key={getProjectRowKey(selectedProject)}
                                sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                  '& td': {
                                    padding: '4px 6px',
                                  }
                                }}
                              >
                                {/* <TableCell align="left">{selectedProject.ID}</TableCell> */}

                                <TableCell padding="checkbox" onClick={handleScrollRight} sx={{ padding: '4px !important' }}>
                                  <IconButton sx={{ backgroundColor: theme.palette.divider,width:"24px",height:"24px" }} >
                                    <ArrowForwardIos color="#ffffff" sx={{width:"14px",fontSize:'0.7rem'}}/>
                                  </IconButton>
                                </TableCell>

                                {/* <TableCell>
                                  <Tooltip title={selectedProject.stockType== 1?"Finished Product" :"Partial Finished Product"}>
                                  <Info/>
                                  </Tooltip>
                                  </TableCell> */}

                                <TableCell align="center">
                                  <Box sx={{ maxWidth: 100 }}>
                                    <Tooltip 
                                      title={
                                        <>
                                          <div><strong>Name:</strong> {selectedProject?.name || ''}</div>
                                          <div><strong>Description:</strong> {selectedProject?.description || ''}</div>
                                        </>
                                      }
                                    >
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          whiteSpace: 'pre-line',
                                          overflowWrap: 'break-word',
                                          color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? '#ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff',
                                          cursor: 'pointer',
                                          fontSize: '0.7rem'
                                        }}
                                      >
                                        {formulaView === 'description'
                                          ? (selectedProject?.description || selectedProject?.name || '')
                                          : (selectedProject?.name || selectedProject?.description || '')}
                                      </Typography>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                                {/* <TableCell>{index + 1}</TableCell> */}
                                
                                <TableCell align="center">
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                  <TextField
                                     sx={{ width: "60px", 
                                       '& .MuiInputBase-root': { height: '28px', fontSize: '0.7rem' },
                                       '& .MuiInputLabel-root': { fontSize: '0.7rem', transform: 'translate(14px, 8px) scale(1)' },
                                       '& .MuiInputLabel-shrink': { transform: 'translate(14px, -6px) scale(0.75)' }
                                     }}
                                    type='number'
                                    label={shortUnitName}
                                    value={selectedProject.quantity}
                                    size="small"
                                    // disabled={selectedProject.stockType == 2 && fullUnitName !== "Unit"}
                                    onFocus={selectInputValue}
                                    onClick={selectInputValue}
                                    onKeyDown={(event) => {
                                      if (event.key === '-' || event.key === '+' || event.key === 'e' ) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onChange={(event) => {
                                      let inputValue = Number(event.target.value);
                                      let maxQuantity = (selectedProject.stockType == 1 ? Number(selectedProject.finishedProductQty) : Number(selectedProject.partialProductQty)) || 1;
                                      console.log('inputValue--inputValue--1',inputValue);
                                      console.log('inputValue--maxQuantity--1',maxQuantity);
                                  
                                      // if (inputValue > maxQuantity) {
                                      //   inputValue = maxQuantity;
                                      // }
                                      const updatedProjects = selectedProjects.map(p => {
                                        if (p.id === selectedProject.id && p.stockType === selectedProject.stockType) {
                                          return {
                                            ...p,
                                            quantity: inputValue
                                          };
                                        }
                                        return p;
                                      });
                                      setSelectedProjects(updatedProjects);
                                      setHasRecipeChanges(true);
                                    }}
                                    // error={Boolean(touched.quantity && errors.quantity)}
                                    // helperText={touched.quantity && errors.quantity}
                                    InputProps={{
                                      inputProps: {
                                        min: 1,
                                        style: { fontSize: '0.7rem', padding: '4px' }
                                        // max: selectedProject.quantity || 1,
                                      }
                                    }}
                                    defaultValue={1}
                                  />
                                  {/* {fullUnitName == "Unit" ? 
                                    <Typography variant="caption" sx={{ color: "red", marginTop: "4px" }}>
                                      {(selectedProject.stockType == 1 ? `Finished Stock : ${Number(selectedProject.finishedProductQty)}` : `Partial Stock : ${Number(selectedProject.partialProductQty)}`) || 0} {shortUnitName}
                                    </Typography> 
                                  : '' } */}
                                </Box>
                                </TableCell>

                                <TableCell align="center">
                                  <Typography variant="caption" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff', fontSize: '0.7rem'}}>${Number(selectedProject?.initial_max_price).toFixed(2)}</Typography>
                                </TableCell>

                                
                            <TableCell align="center" sx={{color:'#1ccaff', fontSize: '0.7rem'}}>{fCurrency(Number(totalWithoutMarkup))}</TableCell> 
                                <TableCell align="center" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff', fontSize: '0.7rem'}}>{Number(selectedProject.retail_price).toFixed(2)}%</TableCell>
                            <TableCell align="center" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff', fontSize: '0.7rem'}}>{fCurrency(Number(markup_price))}</TableCell> 
                            <TableCell align="center" sx={{color:'#fc8c03', fontSize: '0.7rem'}}>{fCurrency(parseFloat(Total)?.toFixed(2))}</TableCell> 
                                <TableCell align="center" sx={{ padding: '4px !important' }}>
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      {
                                        setSelectedProjects([...selectedProjects.filter(selected => !(selected.id === selectedProject.id && selected.stockType === selectedProject.stockType))]);
                                        setHasRecipeChanges(true);
                                      }
                                    }
                                  >
                                    <Icon icon={trash2Outline} width={16} height={16} color={selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff'} />
                                  </IconButton>
                                  {/* <ConfirmationPopup
                                open={deleteConfirmations[row.ID] || false}
                                handleClick={() => {
                                  handleDeleteTask(row.ID);
                                  // Add a delay of one second before closing the popup
                                  setTimeout(() => {
                                    setDeleteConfirmations((prev) => ({
                                      ...prev,
                                      [row.ID]: false,
                                    }));
                                  }, 1000);
                                }}
                                message={'Want to Delete This Task'}
                                handleClose={() =>
                                  setDeleteConfirmations((prev) => ({
                                    ...prev,
                                    [row.ID]: false,
                                  }))
                                }
                              /> */}
                                </TableCell>

                                <TableCell padding="checkbox" onClick={handleScrollLeft} sx={{ padding: '4px !important' }}>
                            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"24px",height:"24px" }} >
                               <ArrowBackIos color="#ffffff" sx={{width:"14px",ml:0.3,fontSize:'0.7rem'}}/>
                          </IconButton>
                              {/* <ArrowBack sx={{cursor:"pointer"}}/> */}
                            </TableCell>
                                {/* <ConfirmationPopup open={isDelete} handleClick={()=>handleDeleteTask(row.ID,row.project_id)} message={'Want to Delete This Task'} handleClose={()=>setIsDelete(false)}/> */}
                              </TableRow>
                            )})}
                            {selectedServices?.filter(selectedProject => selectedProject.name.toLowerCase().includes(filterTermLower)).map((selectedProject, index) => {
                             
                             let totalWithoutMarkup = parseFloat(Number(selectedProject.cost) * selectedProject.quantity).toFixed(2)
                             let markupPercentage=selectedProject?.markup || 0
                             let markup_price = parseFloat((totalWithoutMarkup * markupPercentage) /100).toFixed(2)
                             let Total = parseFloat(Number(totalWithoutMarkup) + Number(markup_price)).toFixed(2)

                             return(
                                 <TableRow
                                key={`${selectedProject.id}-${index}`}
                                sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                  '& td': {
                                    padding: '4px 6px',
                                  }
                                }}
                              >
                                {/* <TableCell align="left">{selectedProject.ID}</TableCell> */}

                                <TableCell padding="checkbox" onClick={handleScrollRight} sx={{ padding: '4px !important' }}>
            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"24px",height:"24px" }} >
            <ArrowForwardIos color="#ffffff" sx={{width:"14px",fontSize:'0.7rem'}}/>
                          </IconButton>
            </TableCell>

            {/* <TableCell>
              <Tooltip title={"Service"}>
              <Info/>
              </Tooltip>
              </TableCell> */}

                                <TableCell align="center" sx={{color:'yellow'}}>
                                  <Box sx={{ maxWidth: 100 }}>
                                    <Typography variant="caption" sx={{ whiteSpace: 'pre-line', overflowWrap: 'break-word', fontSize: '0.7rem' }}>
                                      {selectedProject.name}
                                      {selectedProject.facility_name && (
                                        <Typography variant="caption" sx={{ display: 'block', color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", fontSize: '0.65rem' }}>
                                          ({selectedProject.facility_name})
                                        </Typography>
                                      )}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                {/* <TableCell>{index + 1}</TableCell> */}
                                {/* <TableCell align="center"></TableCell> */}
                                <TableCell align="center" sx={{color:'yellow'}}>
                                  <TextField
                                    sx={{ width: '60px',
                                      '& .MuiInputBase-root': { height: '28px', fontSize: '0.7rem' },
                                      '& .MuiInputLabel-root': { fontSize: '0.7rem', transform: 'translate(14px, 8px) scale(1)' },
                                      '& .MuiInputLabel-shrink': { transform: 'translate(14px, -6px) scale(0.75)' }
                                    }}
                                    type='number'
                                    label="Hours"
                                    size="small"
                                    // disabled
                                    value={selectedProject.quantity}
                                    onFocus={selectInputValue}
                                    onClick={selectInputValue}
                                    onChange={(event) => {
                                  const updatedProjects = selectedServices.map((p, i) => {
                                    if (i === index) { // Match by index instead of ID
                                      return {
                                        ...p,
                                        quantity: event.target.value
                                      };
                                    }
                                    return p;
                                  });
                                      setSelectedServices(updatedProjects);
                                      setHasRecipeChanges(true);
                                    }}
                                    // error={Boolean(touched.quantity && errors.quantity)}
                                    // helperText={touched.quantity && errors.quantity}
                                    InputProps={{
                                      inputProps: {
                                        min: 1,
                                        style: { fontSize: '0.7rem', padding: '4px' }
                                      }
                                    }}
                                    defaultValue={1}
                                  />
                                </TableCell>
                                <TableCell align="center" sx={{color:'yellow', fontSize: '0.7rem'}}>${selectedProject?.cost?.toFixed(2)}</TableCell>
                                {/* <TableCell align="center">
                                  <Typography variant="body1" sx={{ color: theme => theme.palette.text.disabled }}>N/A</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1" sx={{ color: theme => theme.palette.text.disabled }}>N/A</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1" sx={{ color: theme => theme.palette.text.disabled }}>N/A</Typography>
                                </TableCell> */}
                                {/* <TableCell align="center" sx={{color:'yellow'}}>Hrs</TableCell> */}
                                {/* <TableCell align="center" sx={{color:'yellow'}}>${selectedProject?.cost?.toFixed(2)}</TableCell> */}
                            <TableCell align="center" sx={{color:'#1ccaff', fontSize: '0.7rem'}}>{fCurrency(Number(selectedProject.cost) * selectedProject.quantity)}</TableCell> 
                                <TableCell align="center" sx={{color:'yellow', fontSize: '0.7rem'}}>{selectedProject.markup}%</TableCell>
                                <TableCell align="center" sx={{color:'yellow', fontSize: '0.7rem'}}>{fCurrency(Number(markup_price))}</TableCell> 
                               <TableCell align="center" sx={{color:'#fc8c03', fontSize: '0.7rem'}}>{fCurrency(parseFloat(Total)?.toFixed(2))}</TableCell> 
                                <TableCell align="center" sx={{ padding: '4px !important' }}>
                                  <IconButton
                                    size="small"
                                    onClick={() =>
                                      {
                                       setSelectedServices([...selectedServices.filter((_, i) => i !== index)]);
                                        setHasRecipeChanges(true);
                                      }
                                    }
                                  >
                                    <Icon icon={trash2Outline} width={16} height={16} />
                                  </IconButton>
                                </TableCell>

                                <TableCell padding="checkbox" onClick={handleScrollLeft} sx={{ padding: '4px !important' }}>
                            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"24px",height:"24px" }} >
                               <ArrowBackIos color="#ffffff" sx={{width:"14px",ml:0.3,fontSize:'0.7rem'}}/>
                          </IconButton>
                              {/* <ArrowBack sx={{cursor:"pointer"}}/> */}
                            </TableCell>
                            
                              </TableRow>
)})}
                          </TableBody>
                          {/* </Scrollbar> */}
                        </Table>
                      </TableContainer>


                            <>
                              <Grid container spacing={0.5} sx={{ marginY: '6px'  }}>
                                {/* LEFT COLUMN – Expected costs */}
                                <Grid item xs={12} md={4} >
                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                    <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                      <Typography
                                        variant="caption"
                                        sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", fontSize: '0.7rem !important', fontWeight: 'bold', whiteSpace: 'nowrap', lineHeight: 1, margin: 0 }}
                                      >
                                        Expected Material Cost
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center" width={100} sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", padding: '1px 8px' }}>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        {(selectedProjects?.reduce((acc, currentValue) => {
                                          const quantity = Number(currentValue?.quantity) || 0;
                                          const initialMaxPrice = Number(currentValue?.initial_max_price) || 0;
                                          return acc + initialMaxPrice * quantity;
                                        }, 0) || 0).toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </RowResultStyle>

                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                    <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                      <Typography variant="caption" sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        Expected Service Cost
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center" width={100} sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", padding: '1px 8px' }}>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        {(selectedServices?.reduce((acc, currentValue) => {
                                          if (currentValue.id === 10) return acc;
                                          return acc + (currentValue?.cost * currentValue?.quantity);
                                        }, 0) || 0).toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </RowResultStyle>

                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                  <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                  <Typography variant="caption" sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>Expected Product Total</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {(() => {
                                    const expectedMaterialCost = selectedProjects?.reduce((accumulator, currentValue) => {
                                      let maxPrice = Number(currentValue?.max_price) || 0;
                                      let quantity = Number(currentValue?.quantity) || 0;
                                      let conversionQty = Number(currentValue?.convertionQty) || 0;
                                      let initialMaxPrice = Number(currentValue?.initial_max_price) || 0;
                                      let totalWithoutMarkup = initialMaxPrice * quantity;
                                      return accumulator + totalWithoutMarkup;
                                    }, 0) || 0;

                                    const expectedServiceCost = selectedServices?.reduce((accumulator, currentValue) => {
                                      if (currentValue.id == 10) return accumulator;
                                      return accumulator + (currentValue?.cost * currentValue?.quantity);
                                    }, 0) || 0;

                                    return (expectedMaterialCost + expectedServiceCost).toFixed(2);
                                  })()}
                                </Typography>
                              </TableCell>

                            </RowResultStyle>

                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                    <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                      <Typography variant="caption" sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        Expected Install Labor
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center" width={100} sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", padding: '1px 8px' }}>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        {(selectedServices?.reduce((acc, currentValue) => {
                                          if (currentValue.id !== 10) return acc;
                                          const serviceCost =
                                            selectedTab === 'split' || fromSplitEstimate ? currentValue?.total_cost : currentValue?.cost;
                                          return acc + serviceCost * currentValue?.quantity;
                                        }, 0) || 0).toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </RowResultStyle>

                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                    <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                      <Typography variant="caption" sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        Total Expected Cost
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center" width={100} sx={{ color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", padding: '1px 8px' }}>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        {(
                                          (selectedProjects?.reduce((acc, currentValue) => {
                                            const quantity = Number(currentValue?.quantity) || 0;
                                            const initialMaxPrice = Number(currentValue?.initial_max_price) || 0;
                                            return acc + initialMaxPrice * quantity;
                                          }, 0) || 0) +
                                          (selectedServices?.reduce((acc, currentValue) => {
                                            const serviceCost =
                                              (selectedTab === 'split' || fromSplitEstimate) && currentValue.id === 10
                                                ? currentValue?.total_cost
                                                : currentValue?.cost;
                                            return acc + serviceCost * currentValue?.quantity;
                                          }, 0) || 0)
                                        ).toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </RowResultStyle>
                                </Grid>

                                {/* RIGHT COLUMN – Retail costs */}
                                <Grid item xs={12} md={4}>
                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                    <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                      <Typography variant="caption" sx={{ color: '#fc8c03', fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        Material Cost(Retail)
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center" width={100} sx={{ color: '#fc8c03', padding: '1px 8px' }}>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        {(() => {
                                          const totalCost =
                                            selectedProjects?.reduce((acc, currentValue) => {
                                              const quantity = Number(currentValue.quantity) || 0;
                                              return acc + retailProductLineTotal(currentValue.initial_max_price, quantity, currentValue.retail_price);
                                            }, 0) || 0;
                                          return totalCost.toFixed(2);
                                        })()}
                                      </Typography>
                                    </TableCell>
                                  </RowResultStyle>

                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                    <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                      <Typography variant="caption" sx={{ color: '#fc8c03', fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        Service Cost(Retail)
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center" width={100} sx={{ color: '#fc8c03', padding: '1px 8px' }}>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        {(() => {
                                          let totalCost = 0;
                                          selectedServices?.forEach((currentValue) => {
                                            if (currentValue.id === 10) return;
                                            totalCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
                                          });
                                          return totalCost.toFixed(2);
                                        })()}
                                      </Typography>
                                    </TableCell>
                                  </RowResultStyle>

                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                  <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                   <Typography variant="caption" sx={{ color: '#fc8c03', fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>Product Total(Without Install Labor)</Typography>
                                 </TableCell>
                                 <TableCell align="center" width={100} sx={{ color: '#fc8c03' }}>
                                   <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                    {(() => {
                                      let materialCost = selectedProjects?.reduce((acc, currentValue) => {
                                        const quantity = Number(currentValue.quantity) || 0;
                                        return acc + retailProductLineTotal(currentValue.initial_max_price, quantity, currentValue.retail_price);
                                      }, 0) || 0;

                                      let serviceCost = 0;
                                      selectedServices?.forEach((currentValue) => {
                                        if(currentValue.id == 10) return ;
                                        serviceCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
                                      });

                                      return (materialCost + serviceCost).toFixed(2);
                                    })()}
                                  </Typography>
                                </TableCell>
                              </RowResultStyle>

                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                    <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                      <Typography variant="caption" sx={{ color: '#fc8c03', fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        Install Labor(Retail)
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center" width={100} sx={{ color: '#fc8c03', padding: '1px 8px' }}>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        {(() => {
                                          let totalCost = 0;
                                          selectedServices?.forEach((currentValue) => {
                                            if (currentValue.id !== 10) return;
                                            totalCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
                                          });
                                          return totalCost.toFixed(2);
                                        })()}
                                      </Typography>
                                    </TableCell>
                                  </RowResultStyle>

                                  <RowResultStyle sx={{ '& td': { paddingTop: '0px', paddingBottom: '0px' } }}>
                                    <TableCell align="left" colSpan={4} sx={{ padding: '1px 8px', lineHeight: 0.9 }}>
                                      <Typography variant="caption" sx={{ color: '#fc8c03', fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        Total Cost(Retail)
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="center" width={100} sx={{ color: '#fc8c03', padding: '1px 8px' }}>
                                      <Typography variant="caption" sx={{ fontSize: '0.7rem !important', fontWeight: 'bold', lineHeight: 1, margin: 0 }}>
                                        {(() => {
                                          const totalCostProjects =
                                            selectedProjects?.reduce((acc, currentValue) => {
                                              const quantity = Number(currentValue.quantity) || 0;
                                              return acc + retailProductLineTotal(currentValue.initial_max_price, quantity, currentValue.retail_price);
                                            }, 0) || 0;

                                          let totalCostServices = 0;
                                          selectedServices?.forEach((currentValue) => {
                                            totalCostServices += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
                                          });

                                          return (totalCostProjects + totalCostServices).toFixed(2);
                                        })()}
                                      </Typography>
                                    </TableCell>
                                  </RowResultStyle>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: 'flex-start', justifyContent: "flex-start", my: 0.5, mr: 2 }}>
                                    {/* Color indicators for stock types */}
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: 1, mb: 1 }}>
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                        <Box sx={{ width: 14, height: 14, backgroundColor: theme.palette.mode === 'light' ? " #ff5b78" : "#ffc0cb", borderRadius: "15%", border: "1px solid black" }} />
                                        <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>From Partial</Typography>
                                      </Box>
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                        <Box sx={{ width: 14, height: 14, backgroundColor: theme.palette.mode === 'light' ? "#9c7d7d" : "#ffffff", borderRadius: "15%", border: "1px solid black" }} />
                                        <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>From Finished</Typography>
                                      </Box>
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                        <Box sx={{ width: 14, height: 14, backgroundColor: theme.palette.mode === 'light' ? "black" : "yellow", borderRadius: "15%", border: "1px solid black" }} />
                                        <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>Service</Typography>
                                      </Box>
                                    </Box>
                                    {/* Warning Note */}
                                    {/* <Box sx={{ mt: 1, width: '100%' }}>
                                      <Typography variant="caption" sx={{ color: '#fa2828', textAlign: 'left', padding: '4px', fontSize: '0.65rem', lineHeight: 1.4 }}>
                                        <ErrorOutline sx={{ verticalAlign: 'middle', marginRight: '4px', fontSize: '0.9rem' }} />
                                        Please note : Our {selectedTab === 'production'
                                          ? 'Production Formula'
                                          : selectedTab === 'traffic'
                                            ? 'Traffic Formula'
                                            : 'Split Formula'}{' '}
                                        costs are expected costs and may vary based on the materials chosen for a job.
                                      </Typography>
                                    </Box> */}
                                    {/* Submit full screen */}
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        mx: 1,
                                        mb: 1,
                                        mt: 1,
                                        gap: 1
                                      }}
                                    >
                                      {fromAddProductsEdit && recipeId && !hideSaveAsCopy && (
                                        <LoadingButton
                                          loading={isSaveCopyLoading}
                                          variant="outlined"
                                          color="primary"
                                          onClick={handleSaveAsCopy}
                                          disabled={isSubmitting || isSaveCopyLoading}
                                          sx={{ borderRadius: '20px' }}
                                          fullWidth={false}
                                          style={{ flex: 1 }}
                                          startIcon={<FileCopy />}
                                        >
                                          Save as Copy
                                        </LoadingButton>
                                      )}
                                      <LoadingButton
                                        loading={isSubmitting || submitActionLoading}
                                        sx={{ borderRadius: '20px' }}
                                        fullWidth={false}
                                        style={{ margin: 'auto', width: '200px' }}
                                        type="submit"
                                        variant="contained"
                                        disabled={submitActionLoading}
                                        startIcon={fromAddProductsEdit && recipeId ? <Save /> : null}
                                      >
                                        {fromAddProductsEdit && recipeId ? 'Save as Original' : 'Submit'}
                                      </LoadingButton>
                                    </Box>
                                  </Box>
                                </Grid>
                              </Grid>
                            </>
                            {/* {
                              showDetailsWithoutMarkup?
                              <> */}
                          {/* <Box sx={{width:"100%",display:"flex",justifyContent:"flex-end",flexDirection:"row"}}>
                          <Box >

                            <RowResultStyle>
                              <TableCell align="right" colSpan={4} >
                                <Typography variant="body1" sx={{color:'#1ccaff', fontSize: '13px !important', fontWeight: 'bold'}}>Expected Material Cost</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                {(selectedProjects?.reduce((accumulator, currentValue) => {
                                  let maxPrice = Number(currentValue?.max_price) || 0;
                                  let quantity = Number(currentValue?.quantity) || 0;
                                  let conversionQty = Number(currentValue?.convertionQty) || 0;
                                  let initialMaxPrice = Number(currentValue?.initial_max_price) || 0;

                                  // Determine the correct total price calculation
                                  // let totalWithoutMarkup = (currentValue?.stockType == 1 || currentValue?.unit == 4)
                                  //     ? (initialMaxPrice * quantity) // Use initial_max_price if stockType is 1 or unit is 4
                                  //     : (maxPrice * conversionQty);  // Otherwise, use conversion-based calculation
                                  let totalWithoutMarkup = initialMaxPrice * quantity;

                                  return accumulator + totalWithoutMarkup;
                                }, 0) || 0).toFixed(2)}

                                </Typography>
                              </TableCell>

                            </RowResultStyle>

                            <RowResultStyle>
                              <TableCell align="right" colSpan={4} >
                                <Typography variant="body1" sx={{color:'#1ccaff', fontSize: '13px !important', fontWeight: 'bold'}}>Expected Service Cost</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {(selectedServices?.reduce((accumulator, currentValue) => {
                                    if (currentValue.id == 10) return accumulator;
                                    return accumulator + (currentValue?.cost* currentValue?.quantity);
                                  }, 0) || 0).toFixed(2)}
                                </Typography>
                              </TableCell>

                              

                            </RowResultStyle>

                            <RowResultStyle>
                              <TableCell align="right" colSpan={4} >
                                <Typography variant="body1" sx={{color:'#1ccaff', fontSize: '13px !important', fontWeight: 'bold'}}>Expected Install Labor</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {(selectedServices?.reduce((accumulator, currentValue) => {
                                    if(currentValue.id !== 10) return accumulator;
                                    // Use total_cost for split formulas, cost for other types
                                    const serviceCost = (selectedTab === 'split' || fromSplitEstimate) ? currentValue?.total_cost : currentValue?.cost;
                                    return accumulator + (serviceCost * currentValue?.quantity);
                                  }, 0) || 0).toFixed(2)}
                                </Typography>
                              </TableCell>

                              

                            </RowResultStyle>

                            <RowResultStyle>
                              <TableCell align="right" colSpan={4} >
                                <Typography variant="body1" sx={{color:'#1ccaff', fontSize: '13px !important', fontWeight: 'bold'}}>Total Expected Cost</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {((selectedProjects?.reduce((accumulator, currentValue) => {
                                    let maxPrice = Number(currentValue?.max_price) || 0;
                                    let quantity = Number(currentValue?.quantity) || 0;
                                    let conversionQty = Number(currentValue?.convertionQty) || 0;
                                    let initialMaxPrice = Number(currentValue?.initial_max_price) || 0;

                                    // Determine the correct total price calculation
                                    // let totalWithoutMarkup = (currentValue?.stockType == 1 || currentValue?.unit == 4)
                                    //     ? (initialMaxPrice * quantity) // Use initial_max_price if stockType is 1 or unit is 4
                                    //     : (maxPrice * conversionQty);  // Otherwise, use conversion-based calculation
                                    let totalWithoutMarkup = initialMaxPrice * quantity;

                                    return accumulator + totalWithoutMarkup;
                                  }, 0) || 0)+(selectedServices?.reduce((accumulator, currentValue) => {
                                    // Use total_cost for service ID 10 in split formulas, cost for all other cases
                                    const serviceCost = ((selectedTab === 'split' || fromSplitEstimate) && currentValue.id === 10) ? currentValue?.total_cost : currentValue?.cost;
                                    return accumulator + (serviceCost * currentValue?.quantity);
                                  }, 0) || 0)).toFixed(2)}
                                </Typography>

                              </TableCell>

                            </RowResultStyle>
                            <TableCell align="left" colSpan={2} sx={{justifyContent:"flex-start"}}>
                                <Typography variant="body" sx={{color: '#fa2828', textAlign: 'left' }}>
                                  <ErrorOutline sx={{ verticalAlign: 'middle', marginRight: '4px' }} />
                                  Please note : Our {selectedTab === "production" ? "Production Formula" : selectedTab === "traffic" ? "Traffic Formula" : "Split Formula"} costs are expected costs and may vary based on the materials chosen for a job. </Typography>
                              </TableCell>
                            </Box>
                            </Box> */}
                              {/* </>
                              :""
                            } */}
                            {/* <RowResultStyle>
                              <TableCell align="center" colSpan={5} >
                                <Typography variant="body" sx={{color: '#fa2828', textAlign: 'center', padding: '8px' }}>
                                  <ErrorOutline sx={{ verticalAlign: 'middle', marginRight: '4px' }} />
                                  Please note : Our product formula costs are expected costs and may vary based on the materials chosen for a job. </Typography>
                              </TableCell>
                            </RowResultStyle> */}

                          

                    
                  </Form>
                </FormikProvider>
              </Grid>
            </Grid>

          </Grid>
          </Grid>

      </Dialog>
              <Box sx={{ paddingTop: '5px !important', position: 'sticky', top: 0, zIndex: 999, backgroundColor: (theme) => theme.palette.background.default, pb: 1 }}>
                <Stack direction="column" spacing={1}>
                {!fullscreenOpen && (
                <Box sx={{ backgroundColor: 'background.paper', p: 1.5, borderRadius: 1 }}>
                <RecipeFormulaNameTextField
                  ref={recipeNameInputRef}
                  key={`name-row-${recipeId || 'new'}-${initialRecipeName}`}
                  selectedTab={selectedTab}
                  initialValue={recipeNameMirror || initialRecipeName}
                  onDebouncedName={(v) => {
                    setRecipeNameMirror(v)
                    setRecipeNameFieldErrors((prev) => {
                      const next = { ...prev }
                      if (v.trim() && v.length <= FORMULA_NAME_MAX_LENGTH) {
                        delete next.recipe_name
                      }
                      return next
                    })
                  }}
                  error={Boolean(recipeNameFieldErrors.recipe_name)}
                  helperText={recipeNameFieldErrors.recipe_name || ''}
                  InputProps={{
                    sx: {
                      backgroundColor: 'background.paper',
                      borderRadius: 1,
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      zIndex: 99999
                    },
                  }}
                />
                </Box>
                )}
                <Box sx={{ backgroundColor: 'background.paper', p: 1.5, borderRadius: 1 }}>
                <Autocomplete
                        fullWidth
                        id="combo-box-demo"
                        options={workflows}
                        value={selectedWorkflow}
                        onChange={async (event, newValue) => {
                          setFieldValue('workflows', newValue)
                          if(newValue){
                          setSelectedWorkflow(newValue || null)
                          
                          // Remove services from previously selected workflow when switching
                          if (selectedWorkflow) {
                              const oldRawIds = [
                                ...(selectedWorkflow.allServiceIds ? selectedWorkflow.allServiceIds.split(',') : []),
                                // ...(selectedWorkflow.allSkillIds ? selectedWorkflow.allSkillIds.split(',') : [])
                              ];
                              const oldServiceIds = [...new Set(oldRawIds.map(id => parseInt(id.trim())).filter(id => !isNaN(id)))];
                              if (oldServiceIds.length > 0) {
                                setSelectedServices(prevSelected =>
                                    prevSelected.filter(service => !oldServiceIds.includes(service.id))
                                );
                              }
                          }

                     // Auto-select services from workflow's allServiceIds
                          if (newValue) { 
                            const rawIds = [
                              ...(newValue.allServiceIds ? newValue.allServiceIds.split(',') : []),
                              // ...(newValue.allSkillIds ? newValue.allSkillIds.split(',') : [])
                            ];
                           // 1. Keep duplicates in the list
                            const serviceIds = rawIds.map(id => parseInt(id.trim())).filter(id => !isNaN(id)); 
                            if (serviceIds.length > 0) {
                              try {
                                const res = await axios.post(`${REST_API_END_POINT}recipe/get-all-services-optimized`, {
                                  userId: user.user_id,
                                  params: null,
                                  page: 1,
                                  limit: 200, // Use a high limit
                                  serviceIds: [...new Set(serviceIds)], // Query unique IDs for performance
                                  disablePagination: true
                                });
    
                                const fetchedServices = res?.data?.results || [];
    
                                // 2. Expand fetched services back into duplicates based on the original list
                                const servicesToAdd = serviceIds.map(id => {
                                  const match = fetchedServices.find(s => s.id === id);
                                  return match ? { ...match, quantity: 1 } : null;
                                }).filter(Boolean);

                                if (servicesToAdd.length > 0) {
                                  // 3. Append everything (removed the filter that blocks existing ones)
                                  setSelectedServices(prevSelected => [...prevSelected, ...servicesToAdd]);
                                  setHasRecipeChanges(true);
                                }
                              } catch (e) {
                                console.error('Error fetching workflow services', e);
                              }
                            }

                          }

                        }else{
                          // Remove services associated with the previously selected workflow
                          if (selectedWorkflow) {
                            const rawIds = [
                              ...(selectedWorkflow.allServiceIds ? selectedWorkflow.allServiceIds.split(',') : []),
                              // ...(selectedWorkflow.allSkillIds ? selectedWorkflow.allSkillIds.split(',') : [])
                            ];
                            const serviceIds = [...new Set(rawIds.map(id => parseInt(id.trim())).filter(id => !isNaN(id)))];

                            setSelectedServices(prevSelected =>
                              prevSelected.filter(service => !serviceIds.includes(service.id))
                            );
                            setHasRecipeChanges(true);
                          }
                          setSelectedWorkflow(null)
                        }
                         }}
                        renderInput={(params) => (
                          <TextField {...params} required fullWidth
                            error={Boolean(touched.workflows && errors.workflows)}
                            helperText={touched.workflows && errors.workflows}
                            label="Select a Production Workflow" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}

                      />
                </Box>
                      </Stack>

              </Box>
              {fromSplitEstimate && (
                <Box sx={{ }}>
                  <Autocomplete
                    options={(splitRecipeOptions || []).sort((a, b) => 
                      alphanumericCompare(a?.name || '', b?.name || '')
                    )}
                    getOptionLabel={(option) => option?.name || ''}
                    value={splitRecipeOptions.find(
                      (option) => option?.name?.toLowerCase() === (recipeNameMirror || '').toLowerCase()
                    ) || null}
                    onChange={(event, newValue) => {
                      if (newValue?.name) {
                        setFieldValue('recipe_name', newValue.name);
                        recipeNameInputRef.current?.setValue?.(newValue.name);
                        setRecipeNameMirror(newValue.name);
                      setSelectedSplitRecipeId(newValue.id || null);
                      setHasRecipeChanges(false);
                        loadSplitFormulaSelections(newValue?.id);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Choose Existing Split Formula"
                        placeholder="Search split formulas"
                        fullWidth
                      />
                    )}
                  />
                </Box>
              )}
            </Grid>
          <Grid container md={12} xs={12} sx={{ mt:4}}>
            <Grid item md={5} xs={12}>
              <Tabs
                value={currentTab}
                scrollButtons="auto"
                variant="scrollable"
                allowScrollButtonsMobile
                onChange={handleChangeTab}  
                sx={{
                  mb: 0.5,
                  '& .MuiTabs-flexContainer': { gap: 0.5 },
                }}
              >
                {ACCOUNT_TABS.map((tabItem) => (
                  <Tab sx={{ px: 2, minHeight: 36 }}
                  disableRipple
                  key={tabItem.value}
                  label={
                    // <Badge badgeContent={tabItem.count} color="primary">
                      <Typography variant="overline">{capitalCase(tabItem.name)}</Typography>
                    // </Badge>
                  }
                  // icon={tabItem.icon}
                  value={tabItem.value}
                />
                ))}
              </Tabs>
              {tab ? 
                <>
                  <JobCostToolbar filterName={search} onFilterName={(event)=>setSearch(event.target.value)} currentTab={currentTab}/>
                  <Card
                    onScroll={handleScroll}
                    sx={{
                      p: 3,
                      height: '530px',
                      overflowY: 'auto',
                      backgroundColor: 'transparent',
                      background: 'transparent',
                      '&::-webkit-scrollbar': {
                        // width: '0.4em',
                        width: '10px',
                      },
                      '&::-webkit-scrollbar-track': {
                        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        background: 'rgba(255, 255, 255, 0.1)',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        // backgroundColor: 'rgba(0,0,0,.1)',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '4px',
                      },
                    }}
                  >

                    <Grid container spacing={1}>
                      {/* {serviceList
                      ?.filter(post => post.name.toLowerCase().includes(search.toLowerCase())).map((post, index) => ( */}
                      {servicesLoading && filteredServiceCards.length === 0 ? Array.from({ length: 12 }).map((_, index) => (
                        <Grid key={`service-fs-skeleton-${index}`} item xs={6} sm={4} md={4}>
                          <Box sx={{ p: 0.5 }}>
                            <Skeleton variant="rect" height={80} sx={{ borderRadius: 1 }} />
                          </Box>
                        </Grid>
                      )) : filteredServiceCards.map((post, index) => (
                        <Grid key={index} item xs={6} sm={4} md={4}> {/* Adjusted md to 4 */}
                          <Card
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            sx={{
                              minWidth: 100,
                              borderRadius: 1.5,
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: 1,
                              transition: 'transform 0.2s, box-shadow 0.2s',
                              cursor: 'pointer',
                              '&:hover': {
                                transform: 'scale(1.02)',
                                boxShadow: 3,
                              },
                            }}
                            onClick={() => !selectedServiceIds.has(post.id) ? handleServiceClick({ ...post, quantity: 1 }) : enqueueSnackbar('Service Already Added', { variant: 'error' })}
                          >
                            {/* <CardMediaStyle>
                            <CoverImgStyle alt="cover" src={logo} />
                          </CardMediaStyle> */}
                            {/* <Box sx={{ p: 2, textAlign: 'center', justifyContent: 'center' }}>
                              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                <Typography
                                  sx={{ cursor: 'pointer' }}
                                  variant="subtitle2"
                                  align="center"
                                >
                                  {post.name}
                                </Typography>
                              </Stack>
                            </Box> */}
                            <Box sx={{ 
                              p: 2,
                              textAlign: 'center',
                              justifyContent: 'center',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              // height: 'auto',
                              height: '80px',
                              overflow: 'hidden',
                            }}>
                              <Stack
                                direction={'row'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                sx={{
                                  height: '100%',
                                }}
                              >
                                <Tooltip 
                                // title={post.name}
                                title={
                                  <>
                                    <div> {post?.name || ''}</div>
                                    {/* <div><strong>Service Type:</strong> {post?.type_name || ''}</div>
                                    <div><strong>Service Workflow:</strong> {post?.workflow_name || ''}</div>
                                    <div><strong>Hourly Cost:</strong> {post?.cost || ''}</div>
                                    <div><strong>Markup:</strong> {post?.markup || ''}</div>
                                    <div><strong>Total Cost:</strong> {post?.total_cost || ''}</div> */}
                                   
                                  </>
                                }
                                >
                                  <Typography
                                    variant="body2"
                                    align="center"
                                    sx={{
                                      display: '-webkit-box',
                                      WebkitBoxOrient: 'vertical',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      WebkitLineClamp: 3,
                                      lineHeight: '1.2',
                                      maxHeight: '3.6em',
                                      fontSize: '14px',
                                      // cursor: (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? 'default' : 'pointer',
                                    }}
                                  >
                                    {/* {formulaView === 'name' ? (
                                      post?.name
                                    ) : (
                                      post?.description
                                    )} */}
                                    {post.name}
                                  </Typography>
                                </Tooltip>
                              </Stack>
                            </Box>
                          </Card>
                        </Grid>
                      ))}
                      {servicesLoading && filteredServiceCards.length > 0 && Array.from({ length: 4 }).map((_, index) => (
                        <Grid key={`service-fs-skeleton-append-${index}`} item xs={6} sm={4} md={4}>
                          <Box sx={{ p: 0.5 }}>
                            <Skeleton variant="rect" height={80} sx={{ borderRadius: 1 }} />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Card>
                </>
                :
                <>
                  <JobCostToolbar filterName={search} onFilterName={(event)=>setSearch(event.target.value)} currentTab={currentTab}/>
                  <Card
                    onScroll={handleScroll}
                    sx={{
                      p: 3,
                      height: '530px',
                      overflowY: 'auto',
                      backgroundColor: 'transparent',
                      background: 'transparent',
                      '&::-webkit-scrollbar': {
                        // width: '0.4em',
                        width: '10px',
                      },
                      '&::-webkit-scrollbar-track': {
                        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        background: 'rgba(255, 255, 255, 0.1)',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        // backgroundColor: 'rgba(0,0,0,.1)',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '4px',
                      },
                    }}
                  >

                    <Grid container spacing={1}>
                      {/* {productList
                      ?.filter(post => post.name.toLowerCase().includes(search.toLowerCase())).map((post, index) => ( */}
                      {materialsLoading && filteredProductCards.length === 0 ? Array.from({ length: 12 }).map((_, index) => (
                        <Grid key={`material-fs-skeleton-${index}`} item xs={6} sm={4} md={4}>
                          <Box sx={{ p: 0.5 }}>
                            <Skeleton variant="rect" height={80} sx={{ borderRadius: 1 }} />
                          </Box>
                        </Grid>
                      )) : filteredProductCards.map((post, index) => (
                        <Grid key={index} item xs={6} sm={4} md={4}> {/* Adjusted md to 4 */}
                          <Card
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            sx={{
                              minWidth: 100,
                              borderRadius: 1.5,
                              border: '1px solid',
                              borderColor: 'divider',
                              boxShadow: 1,
                              transition: 'transform 0.2s, box-shadow 0.2s',
                              cursor: 'pointer',
                              '&:hover': {
                                transform: 'scale(1.02)',
                                boxShadow: 3,
                              },
                            }}
                            onClick={() => {
                              handleProductClick(post)
                              // handleClickOpen()
                              
                            }}
                          >
                           
                            <Box sx={{ 
                              p: 2,
                              textAlign: 'center',
                              justifyContent: 'center',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              // height: 'auto',
                              height: '80px',
                              overflow: 'hidden',
                            }}>
                              <Stack
                                direction={'row'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                sx={{
                                  height: '100%',
                                }}
                              >
                                <Tooltip 
                                // title={post.name}
                                title={
                                  <>
                                    <div><strong>Name:</strong> {post?.name || ''}</div>
                                    <div><strong>Description:</strong> {post?.description || ''}</div>
                                   
                                  </>
                                }
                                >
                                  <Typography
                                    variant="body2"
                                    align="center"
                                    sx={{
                                      display: '-webkit-box',
                                      WebkitBoxOrient: 'vertical',
                                      whiteSpace: 'pre-line', // ✅ NEW
                                      wordBreak: 'break-word', // ✅ NEW
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      WebkitLineClamp: 3,
                                      lineHeight: '1.2',
                                      maxHeight: '3.6em',
                                      fontSize: '14px',
                                      // cursor: (currentTabNew == "Installations" || currentTabNew == "Completed" || currentTabNew == "Hold") ? 'default' : 'pointer',
                                    }}
                                  >
                                    {/* {post.name} */}
                                    {formulaView === 'name' ? (
                                      post?.name
                                    ) : (
                                      post?.description
                                    )}
                                    {/* {post?.description} */}
                                  </Typography>
                                </Tooltip>
                              </Stack>
                            </Box>
                          </Card>
                        </Grid>
                      ))}
                      {materialsLoading && filteredProductCards.length > 0 && Array.from({ length: 4 }).map((_, index) => (
                        <Grid key={`material-fs-skeleton-append-${index}`} item xs={6} sm={4} md={4}>
                          <Box sx={{ p: 0.5 }}>
                            <Skeleton variant="rect" height={80} sx={{ borderRadius: 1 }} />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Card>
                </>
              }
            </Grid>

            <Grid item md={7} xs={12}>

              <Card>
                <Box sx={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                  <JobCostCartToolbar
                    filterName={filterName}
                    onFilterName={(event)=>setFilterName(event.target.value)}
                    currentTab={currentTab}
                  />
                  {/* Color indicators for stock types */}
                  <Box sx={{ display: "flex",flexDirection:'column', alignItems: "flex-start",justifyContent:'flex-start', gap: 1, my:1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? " #ff5b78" : "#ffc0cb", borderRadius: "20%", border: "1px solid black" }} />
                      <Typography variant="body2">From Partial</Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? "#9c7d7d" : "#ffffff", borderRadius: "20%", border: "1px solid black" }} />
                      <Typography variant="body2">From Finished</Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? "black" : "yellow", borderRadius: "20%", border: "1px solid black" }} />
                      <Typography variant="body2">Service</Typography>
                    </Box>
                  </Box>
                  <Tooltip title="Full Screen">
                    <Fullscreen sx={{mt:4,fontSize:"30px",mr:1}} onClick={handleOpenFullscreen}/>
                  </Tooltip> 
                </Box>
                <FormikProvider value={formik}>
                  <Form noValidate autoComplete="off" onSubmit={handleRecipeFormSubmit}>
                      <TableContainer 
                      ref={tableContainerRef}
sx={{ minWidth: 550,height:'320px', whiteSpace: "nowrap", overflowX: "auto", overflowY: "auto", mt: 1 }}

                      // sx={{ minWidth: 550 }}
                      >
                        <Table stickyHeader>
                          <TableHead
                            sx={{ zIndex:999,
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,whiteSpace:'nowrap',
                              // '& th': { backgroundColor: 'transparent' }
                            }}
                          >
                            <TableRow>

                              {/* <TableCell align="left">
                          <Typography variant="body1" noWrap>ID</Typography>
                        </TableCell> */}
                           <TableCell align="center">
                                <Typography variant="body1" noWrap></Typography>
                              </TableCell>
                              {/* <TableCell align="center">
                                <Typography variant="body1" noWrap></Typography>
                              </TableCell> */}
                              <TableCell align="center">
                                <Typography variant="body1" noWrap>
                                  {formulaView === 'name' ? 'Name' : 'Description'}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1" noWrap>Quantity</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1" noWrap>Unit Cost</Typography>
                              </TableCell>
                            
                        {/* <Tooltip title="Unit Cost * Cut Out Qty"> */}
                        <Tooltip title="Unit Cost * Quantity">
                        <TableCell align="center">
                          <Typography variant="body1" noWrap>Sub Total</Typography>
                        </TableCell> 
                        </Tooltip>


                        <TableCell align="center" sx={{ whiteSpace: 'normal', wordBreak: 'break-word',minWidth: '130px', maxWidth: '150px' }}>
                          <Typography variant="body1">Retail Markup (%)</Typography>
                        </TableCell>

                        <Tooltip title="(Sub Total * Retail Markup) /100">
                        <TableCell align="center" sx={{ whiteSpace: 'normal', wordBreak: 'break-word',minWidth: '130px', maxWidth: '150px' }}>
                          <Typography variant="body1">Retail Amount</Typography>
                        </TableCell>
                        </Tooltip>


                      <Tooltip title="Sub Total + Retail Markup Amount">
                        <TableCell align="center">
                          <Typography variant="body1" noWrap>Total</Typography>
                        </TableCell>
                        </Tooltip>
                        
                              <TableCell align="center">
                                <Typography variant="body1" noWrap></Typography>

                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1" noWrap></Typography>

                              </TableCell>
                            </TableRow>
                          </TableHead>
                          {/* <Scrollbar
                      sx={{
                        height: '320px',minWidth: 550
                      }}> */}
                          <TableBody sx={{overflowY:'auto',}}>
                            {selectedProjects
                              ?.filter((selectedProject) => {
                                const labelValue =
                                  formulaView === 'description'
                                    ? selectedProject?.description
                                    : selectedProject?.name;
                                return (
                                  (labelValue || selectedProject?.name || '')
                                    .toLowerCase()
                                    .includes(filterTermLower)
                                );
                              })
                              .map((selectedProject, index) => {
                              // let unitName = UNITS?.filter((item) => item?.id == selectedProject?.unit);
                                const conversionUnit = selectedProject?.convertion_unit;

                                const selectedUnitId =
                                  Number(selectedProject.stockType) === 1
                                    ? selectedProject?.unit
                                    : conversionUnit != null && Number(conversionUnit) !== 0
                                      ? conversionUnit
                                      : selectedProject?.convertionUnit ?? selectedProject?.unit;

                                const unitName = UNITS?.filter(
                                  (item) => String(item?.id) === String(selectedUnitId)
                                ) || [];
                              let newShortUnitName = unitName?.[0]?.short_name || "";
                              let fullUnitName = unitName?.[0]?.name || "";
                              let shortUnitName = newShortUnitName;
                                     console.log("unitName", unitName);
                                     console.log("shortUnitName", selectedProjects);
                                     console.log("fullUnitName", fullUnitName);

                              // let totalWithoutMarkup = parseFloat(Number(selectedProject.max_price) * selectedProject.quantity).toFixed(2)
                              // let retail_markup=selectedProject?.retail_price || 0
                              // let markup_price = parseFloat((totalWithoutMarkup * retail_markup) /100).toFixed(2)
                              // let Total = parseFloat(Number(totalWithoutMarkup) + Number(markup_price)).toFixed(2)
                              // console.log("calculation ptoducts3",totalWithoutMarkup,markup_price,Total)
                              let totalWithoutMarkup = 0;
                              let retail_markup = selectedProject?.retail_price || 0;
                              let markup_price = 0;
                              let Total = 0;
                              let calculatedPrice = 0;
                              let remainingStockQty = 0;
                              let qtyAfterConversion = 0;
                              let convertionQty = 0
                              const selectedUnit = UNITS.find(unit => unit.id === selectedProject.convertionUnit);
                              const initialUnit = UNITS.find(unit => unit.id === selectedProject.unit);

                              if (true) {
                              // if (selectedProject.stockType == 1 || selectedProject?.unit == 4) {
                                selectedProject.max_price = selectedProject.initial_max_price || 0;
                                totalWithoutMarkup = (Number(selectedProject.initial_max_price) * (selectedProject.quantity));
                                markup_price = (totalWithoutMarkup * retail_markup) / 100;
                                Total = totalWithoutMarkup + markup_price;
                                qtyAfterConversion = selectedProject.quantity || 0;
                              } 
                              // Apply `.toFixed(2)` only at the end for display
                              totalWithoutMarkup = totalWithoutMarkup.toFixed(2);
                              markup_price = markup_price.toFixed(2);
                              Total = Total.toFixed(2);


                              return(
                              <TableRow
                              key={getProjectRowKey(selectedProject)}
                                sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}
                              >
                                {/* <TableCell align="left">{selectedProject.ID}</TableCell> */}

                                <TableCell padding="checkbox" onClick={handleScrollRight}>
                                  <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                    <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                                  </IconButton>
                                </TableCell>

                                {/* <TableCell>
                                  <Tooltip title={selectedProject.stockType== 1?"Finished Product" :"Partial Finished Product"}>
                                  <Info/>
                                  </Tooltip>
                                  </TableCell> */}

                                <TableCell align="center">
                                  <Box sx={{ maxWidth: 100 }}>
                                    <Tooltip 
                                      title={
                                        <>
                                          <div><strong>Name:</strong> {selectedProject?.name || ''}</div>
                                          <div><strong>Description:</strong> {selectedProject?.description || ''}</div>
                                        </>
                                      }
                                    >
                                      <Typography
                                        variant="subtitle2"
                                        sx={{
                                          whiteSpace: 'pre-line',
                                          overflowWrap: 'break-word',
                                          color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff',
                                          cursor: 'pointer'
                                        }}
                                      >
                                        {formulaView === 'description'
                                          ? (selectedProject?.description || selectedProject?.name || '')
                                          : (selectedProject?.name || selectedProject?.description || '')}
                                      </Typography>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                                {/* <TableCell>{index + 1}</TableCell> */}
                                
                                <TableCell align="center" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff'}}>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                  <TextField
                                     sx={{ width: "80px" }}
                                    type='number'
                                    label={shortUnitName}
                                    value={selectedProject.quantity}
                                    // disabled={selectedProject.stockType == 2 && fullUnitName !== "Unit"}
                                    onFocus={selectInputValue}
                                    onClick={selectInputValue}
                                    onKeyDown={(event) => {
                                      if (event.key === '-' || event.key === '+' || event.key === 'e' ) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onChange={(event) => {
                                      let inputValue = Number(event.target.value);
                                      let maxQuantity = (selectedProject.stockType == 1 ? Number(selectedProject.finishedProductQty) : Number(selectedProject.partialProductQty)) || 1;
                                      console.log('inputValue--inputValue--2',inputValue);
                                      console.log('inputValue--maxQuantity--2',maxQuantity);
                                  
                                      // if (inputValue > maxQuantity) {
                                      //   inputValue = maxQuantity;
                                      // }
                                      const updatedProjects = selectedProjects.map(p => {
                                        if (p.id === selectedProject.id && p.stockType === selectedProject.stockType) {
                                          return {
                                            ...p,
                                            quantity: inputValue
                                          };
                                        }
                                        return p;
                                      });
                                      setSelectedProjects(updatedProjects);
                                      setHasRecipeChanges(true);
                                    }}
                                    // error={Boolean(touched.quantity && errors.quantity)}
                                    // helperText={touched.quantity && errors.quantity}
                                    InputProps={{
                                      inputProps: {
                                        min: 1,
                                        // max: selectedProject.quantity || 1,
                                      }
                                    }}
                                    defaultValue={1}
                                  />
                                  {/* {fullUnitName == "Unit" ?
                                    <Typography variant="caption" sx={{ color: "red", marginTop: "4px" }}>
                                      {(selectedProject.stockType == 1 ? `Finished Stock : ${Number(selectedProject.finishedProductQty)}` : `Partial Stock : ${Number(selectedProject.partialProductQty)}`) || 0} {shortUnitName}
                                    </Typography>
                                  : '' } */}
                                </Box>
                                </TableCell>

                                <TableCell align="center">
                                  <Typography variant="body1" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff'}}>${Number(selectedProject?.initial_max_price).toFixed(2)}</Typography>
                                </TableCell>

                            <TableCell align="center" sx={{color:'#1ccaff'}}>{fCurrency(Number(totalWithoutMarkup))}</TableCell> 
                                <TableCell align="center" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff'}}>{Number(selectedProject.retail_price).toFixed(2)}%</TableCell>
                            <TableCell align="center" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff'}}>{fCurrency(Number(markup_price))}</TableCell> 
                            <TableCell align="center" sx={{color:'#fc8c03'}}>{fCurrency(parseFloat(Total)?.toFixed(2))}</TableCell> 
                                <TableCell align="center">
                                  <IconButton
                                    onClick={() =>
                                      {
                                        setSelectedProjects([...selectedProjects.filter(selected => !(selected.id === selectedProject.id && selected.stockType === selectedProject.stockType))]);
                                        setHasRecipeChanges(true);
                                      }
                                    }
                                  >
                                    <Icon icon={trash2Outline} width={20} height={20} color={selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff'} />
                                  </IconButton>
                                
                                </TableCell>

                                <TableCell padding="checkbox" onClick={handleScrollLeft}>
                            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                               <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                          </IconButton>
                              {/* <ArrowBack sx={{cursor:"pointer"}}/> */}
                            </TableCell>
                                {/* <ConfirmationPopup open={isDelete} handleClick={()=>handleDeleteTask(row.ID,row.project_id)} message={'Want to Delete This Task'} handleClose={()=>setIsDelete(false)}/> */}
                              </TableRow>
                            )})}
                            {selectedServices?.filter(selectedProject => selectedProject.name.toLowerCase().includes(filterTermLower)).map((selectedProject, index) => {
                             
                             let totalWithoutMarkup = parseFloat(Number(selectedProject.cost) * selectedProject.quantity).toFixed(2)
                             let markupPercentage=selectedProject?.markup || 0
                             let markup_price = parseFloat((totalWithoutMarkup * markupPercentage) /100).toFixed(2)
                             let Total = parseFloat(Number(totalWithoutMarkup) + Number(markup_price)).toFixed(2)

                             return(
                                 <TableRow
                                 key={getProjectRowKey(selectedProject)}
                                sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                  color: selectedProject.stockType== 2 && theme.palette.mode === 'light' ? ' #ff5b78' : '#ffc0cb'
                                }}
                              >
                                {/* <TableCell align="left">{selectedProject.ID}</TableCell> */}

                                <TableCell padding="checkbox" onClick={handleScrollRight}>
            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
            <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                          </IconButton>
            </TableCell>
                        
            {/* <TableCell>
              <Tooltip title={"Service"}>
              <Info/>
              </Tooltip>
              </TableCell> */}
                                <TableCell align="center" sx={{color:'yellow'}}>
                                  <Box sx={{ maxWidth: 100 }}>
                                    <Tooltip title={selectedProject?.name || ''}>
                                      <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-line', overflowWrap: 'break-word', cursor: 'pointer' }}>
                                        {selectedProject.name}
                                        {selectedProject.facility_name && (
                                          <Typography variant="caption" sx={{ display: 'block', color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff", fontSize: '10px' }}>
                                            ({selectedProject.facility_name})
                                          </Typography>
                                        )}
                                      </Typography>
                                    </Tooltip>
                                  </Box>
                                </TableCell>
                                {/* <TableCell>{index + 1}</TableCell> */}
                                {/* <TableCell align="center"></TableCell> */}
                                <TableCell align="center" sx={{color:'yellow'}}>
                                  <TextField
                                    sx={{ width: '80px' }}
                                    type='number'
                                    label="Hours"
                                    // disabled
                                    value={selectedProject.quantity}
                                    onFocus={selectInputValue}
                                    onClick={selectInputValue}
                                    onChange={(event) => {
                                      const updatedProjects = selectedServices.map(p => {
                                        if (p.id === selectedProject.id) {
                                          return {
                                            ...p,
                                            quantity: event.target.value
                                          };
                                        }
                                        return p;
                                      });
                                      setSelectedServices(updatedProjects);
                                      setHasRecipeChanges(true);
                                    }}
                                    // error={Boolean(touched.quantity && errors.quantity)}
                                    // helperText={touched.quantity && errors.quantity}
                                    InputProps={{
                                      inputProps: {
                                        min: 1,
                                      }
                                    }}
                                    defaultValue={1}
                                  />
                                </TableCell>
                                <TableCell align="center" sx={{color:'yellow'}}>${selectedProject?.cost?.toFixed(2)}</TableCell>

                            {/* <TableCell align="center">
                              <Typography variant="body1" sx={{ color: theme => theme.palette.text.disabled }}>N/A</Typography>
                            </TableCell>


                            <TableCell align="center">
                              <Typography variant="body1" sx={{ color: theme => theme.palette.text.disabled }}>N/A</Typography>
                            </TableCell>

                            <TableCell align="center">
                              <Typography variant="body1" sx={{ color: theme => theme.palette.text.disabled }}>N/A</Typography>
                            </TableCell> */}


                                {/* <TableCell align="center" sx={{color:'yellow'}}>Hrs</TableCell> */}
                                {/* <TableCell align="center" sx={{color:'yellow'}}>${selectedProject?.cost?.toFixed(2)}</TableCell> */}
                            <TableCell align="center" sx={{color:'#1ccaff'}}>{fCurrency(Number(selectedProject.cost) * selectedProject.quantity)}</TableCell> 
                                <TableCell align="center" sx={{color:'yellow'}}>{selectedProject.markup}%</TableCell>
                                <TableCell align="center" sx={{color:'yellow'}}>{fCurrency(Number(markup_price))}</TableCell> 
                               <TableCell align="center" sx={{color:'#fc8c03'}}>{fCurrency(parseFloat(Total)?.toFixed(2))}</TableCell> 
                                <TableCell align="center">
                                  <IconButton
                                    onClick={() =>
                                      {
                                        setSelectedServices([...selectedServices.filter(selected => selected.id !== selectedProject.id)]);
                                        setHasRecipeChanges(true);
                                      }
                                    }
                                  >
                                    <Icon icon={trash2Outline} width={20} height={20} />
                                  </IconButton>
                                </TableCell>

                                <TableCell padding="checkbox" onClick={handleScrollLeft}>
                            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                               <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                          </IconButton>
                              {/* <ArrowBack sx={{cursor:"pointer"}}/> */}
                            </TableCell>
                            
                              </TableRow>
)})}
                          </TableBody>
                        {/* </Scrollbar> */}
                        </Table>
                      </TableContainer>


                    
                    {/* <RowResultStyle>
                              <TableCell align="right" colSpan={4} >
                                <Typography variant="h6" sx={{color:'#fc8c03'}}>Total Retail Markup(%)</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#fc8c03'}}>
                              <Typography variant="h6">{(selectedProjects?.reduce((accumulator, currentValue) => {
                                  return accumulator + (currentValue?.retail_price);
                                }, 0) || 0).toFixed(2)}</Typography>
                              </TableCell>

                            </RowResultStyle> */}

                    <Grid container spacing={1} sx={{ marginY: '10px' }}>
                      <Grid item xs={12} md={6}>
                              <RowResultStyle>
                              {/* <TableCell  width={240}/> */}
                               <TableCell align="left" colSpan={4}>
                                 <Typography variant="body1" sx={{ color: '#fc8c03', fontSize: '13px !important', fontWeight: 'bold' }}>Material Cost(Retail)</Typography>
                               </TableCell>
                               <TableCell align="center" width={100} sx={{ color: '#fc8c03' }}>
                                 <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {(() => {
                                    let totalCost = selectedProjects?.reduce((acc, currentValue) => {
                                      const quantity = Number(currentValue.quantity) || 0;
                                      return acc + retailProductLineTotal(currentValue.initial_max_price, quantity, currentValue.retail_price);
                                    }, 0) || 0; 

                                    return totalCost?.toFixed(2); // Format the final result
                                  })()}
                                </Typography>
                              </TableCell>
                              </RowResultStyle>


                              <RowResultStyle>
                                {/* <TableCell  width={240}/> */}
                                 <TableCell align="left" colSpan={4}>
                                   <Typography variant="body1" sx={{ color: '#fc8c03', fontSize: '13px !important', fontWeight: 'bold' }}>Service Cost(Retail)</Typography>
                                 </TableCell>
                                 <TableCell align="center" width={100} sx={{ color: '#fc8c03' }}>
                                   <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                    {(() => {
                                      let totalCost = 0;

                                      selectedServices?.forEach((currentValue) => {
                                        if(currentValue.id == 10) return ;
                                        totalCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
                                      });

                                      return totalCost.toFixed(2); // Format the final result
                                    })()}
                                  </Typography>
                                </TableCell>
                              </RowResultStyle>
                              <RowResultStyle>
                                {/* <TableCell  width={240}/> */}
                                 <TableCell align="left" colSpan={4}>
                                   <Typography variant="body1" sx={{ color: '#fc8c03', fontSize: '13px !important', fontWeight: 'bold' }}>Product Total(Without Install Labor)</Typography>
                                 </TableCell>
                                 <TableCell align="center" width={100} sx={{ color: '#fc8c03' }}>
                                   <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                    {(() => {
                                      let materialCost = selectedProjects?.reduce((acc, currentValue) => {
                                        const quantity = Number(currentValue.quantity) || 0;
                                        return acc + retailProductLineTotal(currentValue.initial_max_price, quantity, currentValue.retail_price);
                                      }, 0) || 0;

                                      let serviceCost = 0;
                                      selectedServices?.forEach((currentValue) => {
                                        if(currentValue.id == 10) return ;
                                        serviceCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
                                      });

                                      return (materialCost + serviceCost).toFixed(2);
                                    })()}
                                  </Typography>
                                </TableCell>
                              </RowResultStyle>

                              <RowResultStyle>
                                {/* <TableCell  width={240}/> */}
                                 <TableCell align="left" colSpan={4}>
                                   <Typography variant="body1" sx={{ color: '#fc8c03', fontSize: '13px !important', fontWeight: 'bold' }}>Install Labor(Retail)</Typography>
                                 </TableCell>
                                 <TableCell align="center" width={100} sx={{ color: '#fc8c03' }}>
                                   <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                    {(() => {
                                      let totalCost = 0;

                                      selectedServices?.forEach((currentValue) => {
                                        if(currentValue.id !== 10) return ;
                                        totalCost += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
                                      });

                                      return totalCost.toFixed(2); // Format the final result
                                    })()}
                                  </Typography>
                                </TableCell>
                              </RowResultStyle>

                              <RowResultStyle>
                               {/* <TableCell  width={240}/> */}
                                <TableCell align="left" colSpan={4}>
                                  <Typography variant="body1" sx={{ color: '#fc8c03', fontSize: '13px !important', fontWeight: 'bold' }}>Total Cost(Retail)</Typography>
                                </TableCell>
                                <TableCell align="center" width={100} sx={{ color: '#fc8c03' }}>
                                  <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                   {(() => {
                                     let totalCostProjects = 0;
                                     let totalCostServices = 0;
                              
                                     // Calculate total cost for materials
                                    totalCostProjects = selectedProjects?.reduce((acc, currentValue) => {
                                      const quantity = Number(currentValue.quantity) || 0;
                                      return acc + retailProductLineTotal(currentValue.initial_max_price, quantity, currentValue.retail_price);
                                    }, 0) || 0;                                     
                              
                                     // Calculate total cost for services
                                     selectedServices?.forEach((currentValue) => {
                                       totalCostServices += retailServiceLineTotal(currentValue.cost, currentValue.quantity, currentValue?.markup);
                                     });
                              
                                     let totalExpectedCost = totalCostProjects + totalCostServices;
                              
                                     return totalExpectedCost.toFixed(2); // Format the final result
                                   })()}
                                 </Typography>
                                 {/* <Typography variant="h6">{expectedCost}</Typography> */}
                               </TableCell>
                              </RowResultStyle>
                      </Grid>
                      <Grid item xs={12} md={6}>


                              {/* checkbox */}
                            <Box display='none'>
                            <RowResultStyle>
                              <TableCell align="right" colSpan={4} >
                                <Typography variant="subtitle2" >Show expected cost details without markedup</Typography>
                              </TableCell>
                              <TableCell align="right" colSpan={4} >
                                 <Checkbox checked={showDetailsWithoutMarkup}
                                    onChange={(e) => showWIthoutMarkupDetails( e.target.checked)}
                                   />
                              </TableCell>
                            </RowResultStyle>
                            </Box>
                            {/* <Box display='none'>
                            {
                              showDetailsWithoutMarkup?
                              <> */}
                            <RowResultStyle>
                              <TableCell align="left" colSpan={4} >
                                <Typography
                                  variant="body1"
                                  sx={{
                                    color:theme.palette.mode === 'light' ? "#00a6e7" : "#1ccaff",
                                    fontSize: '13px !important',
                                    fontWeight: 'bold',
                                    whiteSpace: 'nowrap'
                                  }}
                                >
                                  Expected Material Cost
                                </Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {(selectedProjects?.reduce((accumulator, currentValue) => {
                                    let maxPrice = Number(currentValue?.max_price) || 0;
                                    let quantity = Number(currentValue?.quantity) || 0;
                                    let conversionQty = Number(currentValue?.convertionQty) || 0;
                                    let initialMaxPrice = Number(currentValue?.initial_max_price) || 0;

                                    // Determine the correct total price calculation
                                    // let totalWithoutMarkup = (currentValue?.stockType == 1 || currentValue?.unit == 4)
                                    //     ? (initialMaxPrice * quantity) // Use initial_max_price if stockType is 1 or unit is 4
                                    //     : (maxPrice * conversionQty);  // Otherwise, use conversion-based calculation
                                    let totalWithoutMarkup = initialMaxPrice * quantity;

                                    return accumulator + totalWithoutMarkup;
                                  }, 0) || 0).toFixed(2)}
                                </Typography>
                              </TableCell>

                            </RowResultStyle>

                            <RowResultStyle>
                              <TableCell align="left" colSpan={4} >
                                <Typography variant="body1" sx={{color:'#1ccaff', fontSize: '13px !important', fontWeight: 'bold'}}>Expected Service Cost</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {(selectedServices?.reduce((accumulator, currentValue) => {
                                    if (currentValue.id == 10) return accumulator;
                                    return accumulator + (currentValue?.cost* currentValue?.quantity);
                                  }, 0) || 0).toFixed(2)}
                                </Typography>
                              </TableCell>

                            </RowResultStyle>

                            <RowResultStyle>
                              <TableCell align="left" colSpan={4} >
                                <Typography variant="body1" sx={{color:'#1ccaff', fontSize: '13px !important', fontWeight: 'bold'}}>Expected Product Total</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {(() => {
                                    const expectedMaterialCost = selectedProjects?.reduce((accumulator, currentValue) => {
                                      let maxPrice = Number(currentValue?.max_price) || 0;
                                      let quantity = Number(currentValue?.quantity) || 0;
                                      let conversionQty = Number(currentValue?.convertionQty) || 0;
                                      let initialMaxPrice = Number(currentValue?.initial_max_price) || 0;
                                      let totalWithoutMarkup = initialMaxPrice * quantity;
                                      return accumulator + totalWithoutMarkup;
                                    }, 0) || 0;

                                    const expectedServiceCost = selectedServices?.reduce((accumulator, currentValue) => {
                                      if (currentValue.id == 10) return accumulator;
                                      return accumulator + (currentValue?.cost * currentValue?.quantity);
                                    }, 0) || 0;

                                    return (expectedMaterialCost + expectedServiceCost).toFixed(2);
                                  })()}
                                </Typography>
                              </TableCell>

                            </RowResultStyle>

                            <RowResultStyle>
                              <TableCell align="left" colSpan={4} >
                                <Typography variant="body1" sx={{color:'#1ccaff', fontSize: '13px !important', fontWeight: 'bold'}}>Expected Install Labor</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {(selectedServices?.reduce((accumulator, currentValue) => {
                                   if (currentValue.id !== 10) return accumulator;
                                    // return accumulator + (currentValue?.cost* currentValue?.quantity);
                                    const serviceCost = (selectedTab === 'split' || fromSplitEstimate) ? currentValue?.total_cost : currentValue?.cost;
                                    return accumulator + (serviceCost * currentValue?.quantity);
                                  }, 0) || 0).toFixed(2)}
                                </Typography>
                              </TableCell>

                              

                            </RowResultStyle>

                            <RowResultStyle>
                              <TableCell align="left" colSpan={4} >
                                <Typography variant="body1" sx={{color:'#1ccaff', fontSize: '13px !important', fontWeight: 'bold'}}>Total Expected Cost</Typography>

                              </TableCell>
                              <TableCell align="center" width={100} sx={{color:'#1ccaff'}}>
                                <Typography variant="body1" sx={{ fontSize: '13px !important', fontWeight: 'bold' }}>
                                  {((selectedProjects?.reduce((accumulator, currentValue) => {
                                    let maxPrice = Number(currentValue?.max_price) || 0;
                                    let quantity = Number(currentValue?.quantity) || 0;
                                    let conversionQty = Number(currentValue?.convertionQty) || 0;
                                    let initialMaxPrice = Number(currentValue?.initial_max_price) || 0;

                                    // Determine the correct total price calculation
                                    // let totalWithoutMarkup = (currentValue?.stockType == 1 || currentValue?.unit == 4)
                                    //     ? (initialMaxPrice * quantity) // Use initial_max_price if stockType is 1 or unit is 4
                                    //     : (maxPrice * conversionQty);  // Otherwise, use conversion-based calculation
                                    let totalWithoutMarkup = initialMaxPrice * quantity;

                                    return accumulator + totalWithoutMarkup;
                                  }, 0) || 0)+(selectedServices?.reduce((accumulator, currentValue) => {
                                    // return accumulator + (currentValue?.cost* currentValue?.quantity);
                                    // Use total_cost for service ID 10 in split formulas, cost for all other cases
                                    const serviceCost = ((selectedTab === 'split' || fromSplitEstimate) && currentValue.id === 10) ? currentValue?.total_cost : currentValue?.cost;
                                    return accumulator + (serviceCost * currentValue?.quantity);
                                  }, 0) || 0)).toFixed(2)}
                                </Typography>
                              </TableCell>
                            </RowResultStyle>
                      </Grid>
                    </Grid>
                            {/* </>
                            :""
                          }
                          </Box> */}
                            <RowResultStyle>
                              <TableCell align="center" colSpan={5} >
                                <Typography variant="body" sx={{color: '#fa2828', textAlign: 'center', padding: '8px' }}>
                                  <ErrorOutline sx={{ verticalAlign: 'middle', marginRight: '4px' }} />
                                  Please note : Our {selectedTab === "production" ? "Production Formula" : selectedTab === "traffic" ? "Traffic Formula" : selectedTab === "estimate" ? "Estimate Formula" : "Split Formula"} costs are expected costs and may vary based on the materials chosen for a job. </Typography>
                              </TableCell>
                            </RowResultStyle>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        mx: 2,
                        mb: 2,
                        mt: 2,
                        gap: 2
                      }}
                    >
                      {fromAddProductsEdit && recipeId && !hideSaveAsCopy && (
                        <LoadingButton
                          loading={isSaveCopyLoading}
                          variant="outlined"
                          color="primary"
                          onClick={handleSaveAsCopy}
                          disabled={isSubmitting || isSaveCopyLoading}
                          sx={{ borderRadius: '20px' }}
                          fullWidth={false}
                          style={{ flex: 1 }}
                          startIcon={<FileCopy />}
                        >
                          Save as Copy
                        </LoadingButton>
                      )}
                      <LoadingButton
                        loading={isSubmitting || submitActionLoading}
                        sx={{ borderRadius: '20px' }}
                        fullWidth={false}
                        style={{ flex: 1 }}
                        type="submit"
                        variant="contained"
                        disabled={submitActionLoading}
                        startIcon={fromAddProductsEdit && recipeId ? <Save /> : null}
                      >
                        {fromAddProductsEdit && recipeId ? 'Save as Original' : 'Submit'}
                      </LoadingButton>
                    </Box>
                  </Form>
                </FormikProvider>
              </Card>
            </Grid>
          </Grid>
            <RecipeLog id={params}  selectedTab={selectedTab}/>
          </Grid>
        </Container>
      
      {/* Catalog Confirmation Dialog - Only show when not fromSplitEstimate */}
      {!fromSplitEstimate && AddCatalogPermission &&(
        <Dialog
          open={openCatalogConfirmation}
          onClose={handleCatalogConfirmationSkip}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Add Catalog</DialogTitle>
          <DialogContent>
            <Typography variant="body1">
              Do you want to add this formula to a catalog?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCatalogConfirmationSkip} variant="outlined" color="primary">
              Skip
            </Button>
            <Button onClick={handleCatalogConfirmationYes} variant="contained" color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Catalog Type Selection Dialog for Production Formula */}
      <Dialog
        open={openCatalogTypeDialog}
        onClose={handleCloseCatalogTypeDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Select Catalog</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={sortedCatalogTypeOptions}
            getOptionLabel={(option) => option.label}
            value={selectedCatalogType}
            onChange={(event, newValue) => {
              if (newValue) {
                handleCatalogTypeSelect(newValue);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Catalog Type"
                placeholder="Choose a catalog type"
                required
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCatalogTypeDialog} variant="outlined" color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Catalog Modal for Adding Product from Recipe */}
      <Modal
        modalTitle="Add Catalog"
        open={openCatalogModal}
        handleClose={handleCloseCatalogModal}
        width={1000}
      >
        <AddProducts 
          fromSplitEstimate={false}
          modalInhouse={selectedTab === 'split' 
            ? 6 
            : selectedTab === 'traffic' 
              ? 1 
              : selectedCatalogType?.inhouse || true}
          modalSelectedTab={selectedTab === 'split' 
            ? 'split_catalog' 
            : selectedTab === 'traffic'
              ? undefined
              : selectedCatalogType?.selectedTab}
          modalIsTrafficCatalog={selectedTab === 'traffic'}
          modalTimeAndMaterial={false}
          onClose={handleCloseCatalogModal}
          productName={savedRecipeData?.name || ''}
          RecipeId={savedRecipeData?.id || null}
          fromRecipeList={true}
        />
      </Modal>
      
      {/* Facility Selection Popup - Only for Split Formulas */}
      {(selectedTab === 'split' || fromSplitEstimate) && (
        <Dialog
          open={facilityPopupOpen}
          onClose={() => {
            setFacilityPopupOpen(false);
            setPendingService(null);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6">Select Facility for Install Labor</Typography>
          </DialogTitle>
          <Box sx={{ p: 3 }}>
            <Autocomplete
              fullWidth
              options={sortedFacilityTypes}
              onChange={(event, newValue) => handleFacilitySelection(newValue)}
              getOptionLabel={(option) => option?.label ?? ''}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose Facility"
                  placeholder="Select facility"
                  required
                />
              )}
            />
          </Box>
          <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setFacilityPopupOpen(false);
                setPendingService(null);
              }}
            >
              Cancel
            </Button>
          </Box>
        </Dialog>
      )}

      {/* Auto-save confirmation dialog */}
      <Dialog
        open={openBackConfirm}
        onClose={() => setOpenBackConfirm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Go back?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to auto save this recipe before going back?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBackConfirmNo} variant="outlined" color="primary">
            No, Go Back
          </Button>
          <Button onClick={handleBackConfirmYes} variant="contained" color="primary">
            Yes, Auto Save
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
